import { BinaryBlobFactory, DataModelFactory } from './models/dto/data-model-factory.js';
import {
  ConnectionStatusPayload, ConnectionStatusPayloadBuilder,
  WhisperPayload, WhisperPayloadBuilder,
  ErrorPayload, ErrorPayloadBuilder,
  BusinessChangedPayload, BusinessChangedPayloadBuilder,
  SeatSelectionRequestPayload, SeatSelectionRequestPayloadBuilder,
  SeatSelectionChangedPayload, SeatSelectionChangedPayloadBuilder,
  SeatPreviewState, SeatPreviewStateBuilder,
  SeatPreviewStatesChangedPayload, SeatPreviewStatesChangedPayloadBuilder,
  SeatWithTicketTemplateDto, SeatWithTicketTemplateDtoBuilder,
  CartDiscountDto, CartDiscountDtoBuilder,
  DiscountChangedPayload, DiscountChangedPayloadBuilder,
  InitializePreviewResponsePayload, InitializePreviewResponsePayloadBuilder,

  IBinaryBlobConverter,
  AdAccount, AdAccountBuilder,
  AdAccountDto, AdAccountDtoBuilder,
  AdCredit, AdCreditBuilder,
  Address, AddressBuilder,
  AddressComponent, AddressComponentBuilder,
  AdvertLocationComponent, AdvertLocationComponentBuilder,
  AdvertProfileComponent, AdvertProfileComponentBuilder,
  AnalyticsSettingsComponent, AnalyticsSettingsComponentBuilder,
  BillingAccount, BillingAccountBuilder,
  BillingDetailsComponent, BillingDetailsComponentBuilder,
  BillingoInvoicingProtocol, BillingoInvoicingProtocolBuilder,
  BlacklistComponent, BlacklistComponentBuilder,
  BookNowComponent, BookNowComponentBuilder,
  BooleanFormInputField, BooleanFormInputFieldBuilder,
  BusinessAppearanceSettings, BusinessAppearanceSettingsBuilder,
  BusinessAppearanceSettingsComponent, BusinessAppearanceSettingsComponentBuilder,
  BusinessClassificationComponent, BusinessClassificationComponentBuilder,
  BusinessDeletedEvent, BusinessDeletedEventBuilder,
  BusinessDetailsSettings, BusinessDetailsSettingsBuilder,
  ModuleSettings, ModuleSettingsBuilder,
  BusinessHours, BusinessHoursBuilder,
  BusinessHoursComponent, BusinessHoursComponentBuilder,
  BusinessHoursDay, BusinessHoursDayBuilder,
  BusinessLocationComponent, BusinessLocationComponentBuilder,
  BusinessModule, BusinessModuleBuilder,
  BusinessPrivacySettings, BusinessPrivacySettingsBuilder,
  BusinessPrivacySettingsComponent, BusinessPrivacySettingsComponentBuilder,
  BusinessProfile, BusinessProfileBuilder,
  BusinessRatingComponent, BusinessRatingComponentBuilder,
  BusinessRatingUpdatedEvent, BusinessRatingUpdatedEventBuilder,
  BusinessRoute, BusinessRouteBuilder,
  BusinessSettings, BusinessSettingsBuilder,
  BusinessSettingsComponent, BusinessSettingsComponentBuilder,
  BusinessUpdatedEvent, BusinessUpdatedEventBuilder,
  BuyTicketComponent, BuyTicketComponentBuilder,
  CalendarBookingSettings, CalendarBookingSettingsBuilder,
  CalendarBookingSettingsComponent, CalendarBookingSettingsComponentBuilder,
  CalendarBreak, CalendarBreakBuilder,
  CalendarEntryAbortedEvent, CalendarEntryAbortedEventBuilder,
  CalendarEntryCanceledEvent, CalendarEntryCanceledEventBuilder,
  CalendarEntryComponent, CalendarEntryComponentBuilder,
  CalendarEntryCreatedEvent, CalendarEntryCreatedEventBuilder,
  CalendarEntryGroupCanceledEvent, CalendarEntryGroupCanceledEventBuilder,
  CalendarEntryRescheduledEvent, CalendarEntryRescheduledEventBuilder,
  CalendarEntryUpdatedEvent, CalendarEntryUpdatedEventBuilder,
  CalendarNote, CalendarNoteBuilder,
  CalendarOrderItem, CalendarOrderItemBuilder,
  CancelNotConfirmedEvent, CancelNotConfirmedEventBuilder,
  CancelNotificationEvent, CancelNotificationEventBuilder,
  CapacityRoom, CapacityRoomBuilder,
  CapacityRange, CapacityRangeBuilder,
  CheckoutRequestResult, CheckoutRequestResultBuilder,
  EventCategoryPrompt, EventCategoryPromptBuilder,
  ClientCacheRefreshEvent, ClientCacheRefreshEventBuilder,
  ClientCreatedEvent, ClientCreatedEventBuilder,
  ClientDeletedEvent, ClientDeletedEventBuilder,
  ClientInviteCode, ClientInviteCodeBuilder,
  ClientInviteComponent, ClientInviteComponentBuilder,
  ClientNoteComponent, ClientNoteComponentBuilder,
  ClientUpdatedEvent, ClientUpdatedEventBuilder,
  ClientsImportedEvent, ClientsImportedEventBuilder,
  CloudNotification, CloudNotificationBuilder,
  ClusteredSchedulingSettings, ClusteredSchedulingSettingsBuilder,
  CommonPrompt, CommonPromptBuilder,
  CompactAppointmentSettings, CompactAppointmentSettingsBuilder,
  LegacyConsentComponent, LegacyConsentComponentBuilder,
  ContactComponent, ContactComponentBuilder,
  Consent, ConsentBuilder,
  ContactDetails, ContactDetailsBuilder,
  CustomImageInfoComponent, CustomImageInfoComponentBuilder,
  CustomInfo, CustomInfoBuilder,
  CustomInfoComponent, CustomInfoComponentBuilder,
  CustomNameComponent, CustomNameComponentBuilder,
  CustomerAccount, CustomerAccountBuilder,
  CustomerAuthDetails, CustomerAuthDetailsBuilder,
  CustomerLocationComponent, CustomerLocationComponentBuilder,
  CustomerProfile, CustomerProfileBuilder,
  CustomerSubscription, CustomerSubscriptionBuilder,
  CustomerTrackingComponent, CustomerTrackingComponentBuilder,
  DailyGenericIncomeStats, DailyGenericIncomeStatsBuilder,
  DailyIncomeStats, DailyIncomeStatsBuilder,
  DailySchedule, DailyScheduleBuilder,
  DailyStatistics, DailyStatisticsBuilder,
  DateSpan, DateSpanBuilder,
  DateSpanComponent, DateSpanComponentBuilder,
  DateTimeFormInputField, DateTimeFormInputFieldBuilder,
  DayOfYear, DayOfYearBuilder,
  DifficultyComponent, DifficultyComponentBuilder,
  Discount, DiscountBuilder,
  DiscoverContent, DiscoverContentBuilder,
  DesktopBridgeInfo, DesktopBridgeInfoBuilder,
  DistanceComponent, DistanceComponentBuilder,
  DurationComponent, DurationComponentBuilder,
  DurationRange, DurationRangeBuilder,
  DynamicApplicationFeeProtocol, DynamicApplicationFeeProtocolBuilder,
  ElevationComponent, ElevationComponentBuilder,
  EmailVerificationCode, EmailVerificationCodeBuilder,
  EventArchivedEvent, EventArchivedEventBuilder,
  EventClassificationComponent, EventClassificationComponentBuilder,
  EventCreatedEvent, EventCreatedEventBuilder,
  EventProduction, EventProductionBuilder,
  EventPrivacySettingsComponent, EventPrivacySettingsComponentBuilder,
  EventProfile, EventProfileBuilder,
  EventPromoCode, EventPromoCodeBuilder,
  EventTicket, EventTicketBuilder,
  EventUpdatedEvent, EventUpdatedEventBuilder,
  FeaturedContactOptionsComponent, FeaturedContactOptionsComponentBuilder,
  FeaturedMetadata, FeaturedMetadataBuilder,
  FeaturedOption, FeaturedOptionBuilder,
  FeaturedTagComponent, FeaturedTagComponentBuilder,
  Fee, FeeBuilder,
  FeeRange, FeeRangeBuilder,
  FeeSettingsComponent, FeeSettingsComponentBuilder,
  FestivalLikes, FestivalLikesBuilder,
  FestivalRaffleEntry, FestivalRaffleEntryBuilder,
  FileReference, FileReferenceBuilder,
  FlexibleServiceDuration, FlexibleServiceDurationBuilder,
  FlexibleServiceDurationComponent, FlexibleServiceDurationComponentBuilder,
  FormComponent, FormComponentBuilder,
  GalleryComponent, GalleryComponentBuilder,
  LegacyTicketBasedSerialNumberPool,
  GeoCoordinates, GeoCoordinatesBuilder,
  GroupOrderComponent, GroupOrderComponentBuilder,
  GroupReservation, GroupReservationBuilder,
  HealthAndSafetyComponent, HealthAndSafetyComponentBuilder,
  HealthAndSafetySettings, HealthAndSafetySettingsBuilder,
  ImageSize, ImageSizeBuilder,
  IntentComponent, IntentComponentBuilder,
  InvoiceSettingsComponent, InvoiceSettingsComponentBuilder,
  KeyValueStore, KeyValueStoreBuilder,
  LabelComponent, LabelComponentBuilder,
  LandscapeRatingComponent, LandscapeRatingComponentBuilder,
  LastActivityComponent, LastActivityComponentBuilder,
  LegacyBookNowComponent, LegacyBookNowComponentBuilder,
  LegacyBusinessPaymentComponent, LegacyBusinessPaymentComponentBuilder,
  LegacyCalendarSnapshot, LegacyCalendarSnapshotBuilder,
  LegacyEventPromoCode, LegacyEventPromoCodeBuilder,
  LegacyLocalizedRichTextComponent, LegacyLocalizedRichTextComponentBuilder,
  LegacyPointOfInterestItem, LegacyPointOfInterestItemBuilder,
  LegacyPointOfInterestItemsComponent, LegacyPointOfInterestItemsComponentBuilder,
  LocalizedProfilePhotosComponent, LocalizedProfilePhotosComponentBuilder,
  LegacyResponsiveImageComponent, LegacyResponsiveImageComponentBuilder,
  LegacyTicketGiftCard, LegacyTicketGiftCardBuilder,
  LegacyTicketSeasonPass, LegacyTicketSeasonPassBuilder,
  Locality, LocalityBuilder,
  LocalizationSettings, LocalizationSettingsBuilder,
  LocalizedDescriptionComponent, LocalizedDescriptionComponentBuilder,
  LocalizedNameComponent, LocalizedNameComponentBuilder,
  LocalizedFileReference, LocalizedFileReferenceBuilder,
  LocalizedPhotoCollection, LocalizedPhotoCollectionBuilder,
  LocalizedPhotoReference, LocalizedPhotoReferenceBuilder,
  LocalizedRichDescription, LocalizedRichDescriptionBuilder,
  LocalizedRichDescriptionComponent, LocalizedRichDescriptionComponentBuilder,
  LocalizedRichTextComponent, LocalizedRichTextComponentBuilder,
  LocalizedString, LocalizedStringBuilder,
  LocationComponent, LocationComponentBuilder,
  LocationHistory, LocationHistoryBuilder,
  MapLocation, MapLocationBuilder,
  MapViewComponent, MapViewComponentBuilder,
  MaxElevationComponent, MaxElevationComponentBuilder,
  MenuCategory, MenuCategoryBuilder,
  MenuComponent, MenuComponentBuilder,
  MenuItem, MenuItemBuilder,
  MonthOfYear, MonthOfYearBuilder,
  MonthlyCalendarSnapshot, MonthlyCalendarSnapshotBuilder,
  MonthlySalesIncomeSummary, MonthlySalesIncomeSummaryBuilder,
  MonthlySalesSummary, MonthlySalesSummaryBuilder,
  MonthlyStaffStatistics, MonthlyStaffStatisticsBuilder,
  NewsContent, NewsContentBuilder,
  NewsPost, NewsPostBuilder,
  NoteComponent, NoteComponentBuilder,
  NTAKAccountSettings, NTAKAccountSettingsBuilder,
  NTAKProgramSettings, NTAKProgramSettingsBuilder,
  NTAKSettingsComponent, NTAKSettingsComponentBuilder,
  Nutrients, NutrientsBuilder,
  OccasionsComponent, OccasionsComponentBuilder,
  OnLocationPaymentComponent, OnLocationPaymentComponentBuilder,
  OnlineCalendarOrder, OnlineCalendarOrderBuilder,
  OnlinePaymentDetails, OnlinePaymentDetailsBuilder,
  OnlineProductOrder, OnlineProductOrderBuilder,
  OnlineEventTicketOrder, OnlineEventTicketOrderBuilder,
  OnlineEventTicketOrderItem, OnlineEventTicketOrderItemBuilder,
  OpenReservation, OpenReservationBuilder,
  OpenReservationDeletedEvent, OpenReservationDeletedEventBuilder,
  OrderReview, OrderReviewBuilder,
  OpenTicketPass, OpenTicketPassBuilder,
  OpenTicketPassComponent, OpenTicketPassComponentBuilder,
  OptionSelectFormInputField, OptionSelectFormInputFieldBuilder,
  LegacyOrderHook, LegacyOrderHookBuilder,
  Organization, OrganizationBuilder,
  OutdoorActivityComponent, OutdoorActivityComponentBuilder,
  OwnersComponent, OwnersComponentBuilder,
  PartnerAccount, PartnerAccountBuilder,
  PaymentAccount, PaymentAccountBuilder,
  PaymentAccountRef, PaymentAccountRefBuilder,
  PaymentIntent, PaymentIntentBuilder,
  PaymentRequestResult, PaymentRequestResultBuilder,
  LegacyPaymentSettings, LegacyPaymentSettingsBuilder,
  LegacyPaymentSettingsComponent, LegacyPaymentSettingsComponentBuilder,
  PhoneCalendarOrder, PhoneCalendarOrderBuilder,
  PhoneContact, PhoneContactBuilder,
  PhotoCollection, PhotoCollectionBuilder,
  PhotoReference, PhotoReferenceBuilder,
  PhotoLOD, PhotoLODBuilder,
  PoiReview, PoiReviewBuilder,
  PoliciesSettings, PoliciesSettingsBuilder,
  PrintingSettings, PrintingSettingsBuilder,
  Place, PlaceBuilder,
  PlaceComponent, PlaceComponentBuilder,
  PointOfInterestComponent, PointOfInterestComponentBuilder,
  PointOfInterestDistribution, PointOfInterestDistributionBuilder,
  PointOfInterestTagComponent, PointOfInterestTagComponentBuilder,
  PoolAttendanceComponent, PoolAttendanceComponentBuilder,
  PoolAttendanceGroup, PoolAttendanceGroupBuilder,
  PoolBookingSettings, PoolBookingSettingsBuilder,
  PoolBookingSettingsComponent, PoolBookingSettingsComponentBuilder,
  PoolCheckIn, PoolCheckInBuilder,
  PoolCheckInEvent, PoolCheckInEventBuilder,
  PoolCheckOutEvent, PoolCheckOutEventBuilder,
  PoolPricingSettings, PoolPricingSettingsBuilder,
  PoolPricingSettingsComponent, PoolPricingSettingsComponentBuilder,
  PoolReservation, PoolReservationBuilder,
  PoolReservationCreatedEvent, PoolReservationCreatedEventBuilder,
  PoolReservationDeletedEvent, PoolReservationDeletedEventBuilder,
  PoolServiceDurationComponent, PoolServiceDurationComponentBuilder,
  PoolWeeklyScheduleComponent, PoolWeeklyScheduleComponentBuilder,
  PriceRange, PriceRangeBuilder,
  PricingDetailsComponent, PricingDetailsComponentBuilder,
  Product, ProductBuilder,
  ProductAssignment, ProductAssignmentBuilder,
  ProductListComponent, ProductListComponentBuilder,
  ProductOrderItem, ProductOrderItemBuilder,
  ProductSellingSettings, ProductSellingSettingsBuilder,
  ProfileElement, ProfileElementBuilder,
  ProfileElementCacheComponent, ProfileElementCacheComponentBuilder,
  ProfileElementGroupComponent, ProfileElementGroupComponentBuilder,
  ProfileElementListComponent, ProfileElementListComponentBuilder,
  ProfileElementRef, ProfileElementRefBuilder,
  ProfilePageLink, ProfilePageLinkBuilder,
  ProfilePageListComponent, ProfilePageListComponentBuilder,
  ProfilePhotosComponent, ProfilePhotosComponentBuilder,
  PromoCodeConsentComponent, PromoCodeConsentComponentBuilder,
  PromoterEventStats, PromoterEventStatsBuilder,
  PromoterEventSubscription, PromoterEventSubscriptionBuilder,
  PromoterProfile, PromoterProfileBuilder,
  PromoterStats, PromoterStatsBuilder,
  PublishingStatusComponent, PublishingStatusComponentBuilder,
  PushNotificationIntent, PushNotificationIntentBuilder,
  RelatedPointsOfInterestComponent, RelatedPointsOfInterestComponentBuilder,
  RescheduleNotConfirmedEvent, RescheduleNotConfirmedEventBuilder,
  RescheduleNotificationEvent, RescheduleNotificationEventBuilder,
  ResponsiveImageComponent, ResponsiveImageComponentBuilder,
  ReviewComponent, ReviewComponentBuilder,
  ReviewStatistics, ReviewStatisticsBuilder,
  RichDescription, RichDescriptionBuilder,
  ScanStatistics, ScanStatisticsBuilder,
  ScheduleTemplate, ScheduleTemplateBuilder,
  ScheduleTimeSpan, ScheduleTimeSpanBuilder,
  ScheduledOrderComponent, ScheduledOrderComponentBuilder,
  SeatReservation, SeatReservationBuilder,
  SeatingLayout, SeatingLayoutBuilder,
  SeatingOptions, SeatingOptionsBuilder,
  EventSeatSelectionLock, EventSeatSelectionLockBuilder,
  PassSeatSelectionLock, PassSeatSelectionLockBuilder,
  SeatingSettingsComponent, SeatingSettingsComponentBuilder,
  EventSeatingState, EventSeatingStateBuilder,
  Secret, SecretBuilder,
  Service, ServiceBuilder,
  ServiceAttendanceComponent, ServiceAttendanceComponentBuilder,
  ServiceAttendanceGroup, ServiceAttendanceGroupBuilder,
  ServiceAudienceComponent, ServiceAudienceComponentBuilder,
  ServiceCapacityComponent, ServiceCapacityComponentBuilder,
  ServiceDuration, ServiceDurationBuilder,
  ServiceDurationComponent, ServiceDurationComponentBuilder,
  ServiceModifier, ServiceModifierBuilder,
  ServiceModifierComponent, ServiceModifierComponentBuilder,
  ServicePaymentComponent, ServicePaymentComponentBuilder,
  ServicePhotosComponent, ServicePhotosComponentBuilder,
  ServicePriceComponent, ServicePriceComponentBuilder,
  ServiceStaffMembersComponent, ServiceStaffMembersComponentBuilder,
  EventShortCode, EventShortCodeBuilder,
  BusinessShortCode, BusinessShortCodeBuilder,
  ShortCodePool, ShortCodePoolBuilder,
  StaffInviteCode, StaffInviteCodeBuilder,
  StaffNoteComponent, StaffNoteComponentBuilder,
  StaffPrivacySettings, StaffPrivacySettingsBuilder,
  StaffProfessionsComponent, StaffProfessionsComponentBuilder,
  StaffProfile, StaffProfileBuilder,
  StaffRole, StaffRoleBuilder,
  LegacyStaffRoleComponent, LegacyStaffRoleComponentBuilder,
  StaffSettings, StaffSettingsBuilder,
  BusinessMembership, BusinessMembershipBuilder,
  StaticApplicationFeeProtocol, StaticApplicationFeeProtocolBuilder,
  Subscription, SubscriptionBuilder,
  SubscriptionBadgeComponent, SubscriptionBadgeComponentBuilder,
  TargetAudience, TargetAudienceBuilder,
  TargetAudienceRule, TargetAudienceRuleBuilder,
  TextFormInputField, TextFormInputFieldBuilder,
  TicketBatch, TicketBatchBuilder,
  TicketGiftCard, TicketGiftCardBuilder,
  GiftCard, GiftCardBuilder,
  GiftCardRedemption, GiftCardRedemptionBuilder,
  GiftCardTemplate, GiftCardTemplateBuilder,
  GiftCardVariation, GiftCardVariationBuilder,
  GiftCardValidity, GiftCardValidityBuilder,
  TicketGiftCardComponent, TicketGiftCardComponentBuilder,
  TicketJob, TicketJobBuilder,
  EventTicketOrder, EventTicketOrderBuilder,
  LegacyTicketPool, LegacyTicketPoolBuilder,
  TicketScannedEvent, TicketScannedEventBuilder,
  TicketSellingSettings, TicketSellingSettingsBuilder,
  TicketTemplate, TicketTemplateBuilder,
  TicketTemplateComponent, TicketTemplateComponentBuilder,
  TicketTemplateRef, TicketTemplateRefBuilder,
  CascadingTicketAvailabilityModifier, CascadingTicketAvailabilityModifierBuilder,
  TimeOfDay, TimeOfDayBuilder,
  TimeSpan, TimeSpanBuilder,
  TouristSignComponent, TouristSignComponentBuilder,
  TrailComponent, TrailComponentBuilder,
  UnknownDataModelTypePolicy,
  WeeklySchedule, WeeklyScheduleBuilder,
  WeeklyScheduleDay, WeeklyScheduleDayBuilder,
  DynamicPricingSettings, DynamicPricingSettingsBuilder,
  DynamicPricingSettingsComponent, DynamicPricingSettingsComponentBuilder,
  ProtocolTicketOrderCreatedEvent, ProtocolTicketOrderCreatedEventBuilder,
  ProtocolProductOrderCreatedEvent, ProtocolProductOrderCreatedEventBuilder,
  TicketOrderCreatedEvent, TicketOrderCreatedEventBuilder,
  DailyTicketSalesStats, DailyTicketSalesStatsBuilder,
  DailyTicketStats, DailyTicketStatsBuilder,
  TrackingPromoCode, TrackingPromoCodeBuilder,
  SeatingRoom, SeatingRoomBuilder,
  Building, BuildingBuilder,
  LegacySeatingLayout, LegacySeatingLayoutBuilder,
  RoomSearchData, RoomSearchDataBuilder,
  LegacySeatingSettingsComponent, LegacySeatingSettingsComponentBuilder,
  PrintedCardCover, PrintedCardCoverBuilder,
  PrintedCardCoverComponent, PrintedCardCoverComponentBuilder,
  PrintedTicketOrderCreatedEvent, PrintedTicketOrderCreatedEventBuilder,
  LegacyPriceBasedSerialNumberPool,
  OpenAccessPassTemplate, OpenAccessPassTemplateBuilder,
  OpenAccessPass, OpenAccessPassBuilder,
  EventOpenAccessProtocol, EventOpenAccessProtocolBuilder,
  SeatedOpenAccessProtocol, SeatedOpenAccessProtocolBuilder,
  Stage, StageBuilder, StageEntry, StageEntryBuilder,
  StagedSeatedOpenAccessProtocol, StagedSeatedOpenAccessProtocolBuilder,
  LimitedTimeAccessProtocol, LimitedTimeAccessProtocolBuilder,
  LimitedUseAccessProtocol, LimitedUseAccessProtocolBuilder,
  FlexiblePassProtocol, FlexiblePassProtocolBuilder,
  OpenAccessPassCreatedEvent, OpenAccessPassCreatedEventBuilder,
  OpenAccessPassTemplateUpdatedEvent, OpenAccessPassTemplateUpdatedEventBuilder,
  OpenAccessPassTemplateCreatedEvent, OpenAccessPassTemplateCreatedEventBuilder,
  OpenAccessScan, OpenAccessScanBuilder,
  BusinessPromoCode, BusinessPromoCodeBuilder,
  OpenAccessPassUpdatedEvent, OpenAccessPassUpdatedEventBuilder,
  SeatReservationItem, SeatReservationItemBuilder,
  GuestAccount, GuestAccountBuilder,
  VoucherAttachmentComponent, VoucherAttachmentComponentBuilder,
  NTAKTicketSettings, NTAKTicketSettingsBuilder,
  NTAKTicketSettingsComponent, NTAKTicketSettingsComponentBuilder,
  CollaboratorEventAccessComponent, CollaboratorEventAccessComponentBuilder,
  BillingProfile, BillingProfileBuilder,
  LegacyBillingDetailsComponent, LegacyBillingDetailsComponentBuilder,
  PercentagePromoCodeProtocol, PercentagePromoCodeProtocolBuilder,
  FixedPromoCodeProtocol, FixedPromoCodeProtocolBuilder,
  DownToPricePromoCodeProtocol, DownToPricePromoCodeProtocolBuilder,
  CurrencySettings, CurrencySettingsBuilder,
  CurrencySettingsComponent, CurrencySettingsComponentBuilder,
  CollaboratorProfile, CollaboratorProfileBuilder,
  LegacyInvoiceDetails, LegacyInvoiceDetailsBuilder,
  GenericPermissionMatrix, GenericPermissionMatrixBuilder,
  NTAKCustomerDetails, NTAKCustomerDetailsBuilder,
  NTAKCustomerDetailsComponent, NTAKCustomerDetailsComponentBuilder,
  TicketReservation, TicketReservationBuilder,
  TicketReservationItem, TicketReservationItemBuilder,
  OpenAccessPassComponent, OpenAccessPassComponentBuilder,
  CoverImageComponent, CoverImageComponentBuilder,
  TitleComponent, TitleComponentBuilder,
  OfflineTicketOrderCreatedEvent, OfflineTicketOrderCreatedEventBuilder,
  BackstageEventComponent, BackstageEventComponentBuilder,
  BackstageTicketComponent, BackstageTicketComponentBuilder,
  BackstageEvent, BackstageEventBuilder,
  BackstageTicket, BackstageTicketBuilder,
  GateOpenTimeComponent, GateOpenTimeComponentBuilder,
  TicketCartLimitComponent, TicketCartLimitComponentBuilder,
  Refund, RefundBuilder,
  HomePageInfo, HomePageInfoBuilder,
  SearchSnapshot, SearchSnapshotBuilder,
  DiscoverPageInfo, DiscoverPageInfoBuilder,
  SzamlazzInvoicingProtocol, SzamlazzInvoicingProtocolBuilder,
  TaxIdentifierTrackingComponent, TaxIdentifierTrackingComponentBuilder,
  TaxIdentificationDetails, TaxIdentificationDetailsBuilder,
  TaxIdentificationProvidedEvent, TaxIdentificationProvidedEventBuilder,
  TaxIdentificationRequest, TaxIdentificationRequestBuilder,
  TicketTemplateCategory, TicketTemplateCategoryBuilder,
  TicketTemplateCategoryComponent, TicketTemplateCategoryComponentBuilder,
  ArtistProfile, ArtistProfileBuilder,
  BrandProfile, BrandProfileBuilder,
  EventAssociations, EventAssociationsBuilder,
  EventProfileAssociations, EventProfileAssociationsBuilder,
  OrganizerProfile, OrganizerProfileBuilder,
  ArtistPageInfo, ArtistPageInfoBuilder,
  BrandPageInfo, BrandPageInfoBuilder,
  OrganizerPageInfo, OrganizerPageInfoBuilder,
  ThirdPartyEventTicket, ThirdPartyEventTicketBuilder,
  ThirdPartyTicketScannedEvent, ThirdPartyTicketScannedEventBuilder,
  ArtificialSeatLockingComponent, ArtificialSeatLockingComponentBuilder,
  ArtificialSeatLockingSettings, ArtificialSeatLockingSettingsBuilder,
  CustomerCreatedEvent, CustomerCreatedEventBuilder,
  CustomerUpdatedEvent, CustomerUpdatedEventBuilder,
  GymPassOrder, GymPassOrderBuilder,
  GymAccessProtocol, GymAccessProtocolBuilder,
  OpenAccessPassPool, OpenAccessPassPoolBuilder,
  GymPassPresence, GymPassPresenceBuilder,
  OpenAccessPassRenewalRequest, OpenAccessPassRenewalRequestBuilder,
  TemplateBasedSerialNumberPool, TemplateBasedSerialNumberPoolBuilder,
  PriceBasedSerialNumberPool, PriceBasedSerialNumberPoolBuilder,
  LegacyTicketBasedSerialNumberPoolMigratingBuilder,
  LegacyPriceBasedSerialNumberPoolMigratingBuilder,
  NFCWritePayload, NFCWritePayloadBuilder,
  OpenAccessPassForSale, OpenAccessPassForSaleBuilder,
  DateFormatComponent, DateFormatComponentBuilder,
  LegacyTicketBookingSettingsComponent, LegacyTicketBookingSettingsComponentBuilder,
  LegacyTicketBookingSettings, LegacyTicketBookingSettingsBuilder,
  OfflinePaymentDetails, OfflinePaymentDetailsBuilder,
  LegacyReceipt, LegacyReceiptBuilder,
  PassSeatingState, PassSeatingStateBuilder,
  SoldTicketsPool, SoldTicketsPoolBuilder,
  StandardTicketPool, StandardTicketPoolBuilder,
  ShardedTicketPool, ShardedTicketPoolBuilder,
  TicketPoolShard, TicketPoolShardBuilder,
  ShardedTicketPoolMaintenanceLock, ShardedTicketPoolMaintenanceLockBuilder,
  OpenAccessPassSeatLockUpdatedEvent, OpenAccessPassSeatLockUpdatedEventBuilder,
  TicketScanColorComponent, TicketScanColorComponentBuilder,
  TicketSalesModeComponent, TicketSalesModeComponentBuilder,
  TicketSeatColorComponent, TicketSeatColorComponentBuilder,
  NFCPassRef, NFCPassRefBuilder,
  PassEventOverrideIntentComponent, PassEventOverrideIntentComponentBuilder,
  AddEventToSeatedOpenAccessProtocol, AddEventToSeatedOpenAccessProtocolBuilder,
  RemoveEventFromSeatedOpenAccessProtocol, RemoveEventFromSeatedOpenAccessProtocolBuilder,
  RateLimiterLock, RateLimiterLockBuilder,
  PredefinedTemplateComponent, PredefinedTemplateIdComponentBuilder,
  NTAKServiceLocation, NTAKServiceLocationBuilder,
  NTAKEventSettingsComponent, NTAKEventSettingsComponentBuilder,
  AuditLogEntryDto, AuditLogEntryDtoBuilder,
  OnlineEventTicketOrderAbortedEntry, OnlineEventTicketOrderAbortedEntryBuilder,
  OnlineEventTicketOrderCanceledEntry, OnlineEventTicketOrderCanceledEntryBuilder,
  OnlineEventTicketOrderCompletedEntry, OnlineEventTicketOrderCompletedEntryBuilder,
  OnlineEventTicketOrderCreatedEntry, OnlineEventTicketOrderCreatedEntryBuilder,
  OnlineEventTicketOrderRefundedEntry, OnlineEventTicketOrderRefundedEntryBuilder,
  OfflineEventTicketOrderCreatedEntry, OfflineEventTicketOrderCreatedEntryBuilder,
  OfflineEventTicketOrderCompletedEntry, OfflineEventTicketOrderCompletedEntryBuilder,
  OfflineEventTicketOrderAbortedEntry, OfflineEventTicketOrderAbortedEntryBuilder,
  OfflineEventTicketOrderModifiedEntry, OfflineEventTicketOrderModifiedEntryBuilder,
  OnlineProductOrderCreatedEntry, OnlineProductOrderCreatedEntryBuilder,
  OnlineProductOrderAbortedEntry, OnlineProductOrderAbortedEntryBuilder,
  OnlineProductOrderCanceledEntry, OnlineProductOrderCanceledEntryBuilder,
  OnlineProductOrderRefundedEntry, OnlineProductOrderRefundedEntryBuilder,
  OnlineProductOrderCompletedEntry, OnlineProductOrderCompletedEntryBuilder,
  OnlineEventPassOrderCreatedEntry, OnlineEventPassOrderCreatedEntryBuilder,
  OpenAccessPassCreatedForLegacyBackendEntry, OpenAccessPassCreatedForLegacyBackendEntryBuilder,
  OpenAccessPassModifiedEventsEntry, OpenAccessPassModifiedEventsEntryBuilder,
  OpenAccessPassModifiedMaxCountEntry, OpenAccessPassModifiedMaxCountEntryBuilder,
  OpenAccessPassRefundedForLegacyBackendEntry, OpenAccessPassRefundedForLegacyBackendEntryBuilder,
  SeatedOpenAccessPassMovedEntry, SeatedOpenAccessPassMovedEntryBuilder,
  SeatedOpenAccessPassSwappedEntry, SeatedOpenAccessPassSwappedEntryBuilder,
  BusinessLevelMarketingSettings, BusinessLevelMarketingSettingsBuilder,
  MarketingConsent, MarketingConsentBuilder,
  BusinessLevelMarketingSubscriptionRequest, BusinessLevelMarketingSubscriptionRequestBuilder,
  LegacyOrderVoucherComponent, LegacyOrderVoucherComponentBuilder,
  OrderDiscountCodeComponent, OrderDiscountCodeComponentBuilder,
  SeatedOfflineEventTicketSwapEntry, SeatedOfflineEventTicketSwapEntryBuilder,
  SeatedOnlineEventTicketSwapEntry, SeatedOnlineEventTicketSwapEntryBuilder,
  OfflineEventTicketOrderPaymentMethodChangedEntry, OfflineEventTicketOrderPaymentMethodChangedEntryBuilder,
  AdminOrderPaymentMethodChangedEntry, AdminOrderPaymentMethodChangedEntryBuilder,
  BusinessLevelMarketingSubscriber, BusinessLevelMarketingSubscriberBuilder,
  MailchimpSettings, MailchimpSettingsBuilder,
  MailchimpSubscription, MailchimpSubscriptionBuilder,
  MailerliteSettings, MailerliteSettingsBuilder,
  MailerliteSubscription, MailerliteSubscriptionBuilder,
  BusinessLevelMarketingInfo, BusinessLevelMarketingInfoBuilder,
  PersistenceOnlySettings, PersistenceOnlySettingsBuilder,
  PersistenceOnlySubscription, PersistenceOnlySubscriptionBuilder,
  OnlineCartDto, OnlineCartDtoBuilder,
  OfflineEventCartDto, OfflineEventCartDtoBuilder,
  TicketCartItemWithQuantityDto, TicketCartItemWithQuantityDtoBuilder,
  TicketCartItemWithSeatingDto, TicketCartItemWithSeatingDtoBuilder,
  ProductCartItemDto, ProductCartItemDtoBuilder,
  TicketEmailOverride, TicketEmailOverrideBuilder,
  DonationSettings, DonationSettingsBuilder,
  OnlineInvoicingDetails, OnlineInvoicingDetailsBuilder,
  InvoiceGroup, InvoiceGroupBuilder,
  InvoiceAction, InvoiceActionBuilder,
  Invoice, InvoiceBuilder,
  EventMembership, EventMembershipBuilder,
  DonationPlaceholder, DonationPlaceholderBuilder,
  OpenAccessPassVariation, OpenAccessPassVariationBuilder,
  OpenAccessPassVariationDetails, OpenAccessPassVariationDetailsBuilder,
  LegacyPassCartDto, LegacyPassCartDtoBuilder,
  LegacyOpenAccessPassCartItemDto, LegacyOpenAccessPassCartItemDtoBuilder,
  LegacySeatedAccessPassCartItemDto, LegacySeatedAccessPassCartItemDtoBuilder,
  OfflineGiftCardCartDto, OfflineGiftCardCartDtoBuilder,
  GiftCardCartItemDto, GiftCardCartItemDtoBuilder,
  OpenAccessPassBatchCreatedEvent, OpenAccessPassBatchCreatedEventBuilder,
  OnlineEventPassOrder, OnlineEventPassOrderBuilder,
  OfflineProductOrderCreatedEvent, OfflineProductOrderCreatedEventBuilder,
  TicketSupplementTemplate, TicketSupplementTemplateBuilder,
  TicketSupplement, TicketSupplementBuilder,
  GiftCardDetails, GiftCardDetailsBuilder,
  TicketSupplementSettings, TicketSupplementSettingsBuilder,
  OnlineProductOrderCanceledEvent, OnlineProductOrderCanceledEventBuilder,
  PublicProfileClassificationComponent, PublicProfileClassificationComponentBuilder,
  OrderCleanupRequest, OrderCleanupRequestBuilder,
  VoucherForOfflineUsage, VoucherForOfflineUsageBuilder,
  AnalyticsCartDto, AnalyticsCartDtoBuilder,
  AnalyticsCartItemDto, AnalyticsCartItemDtoBuilder,
  Campaign, CampaignBuilder,
  AdSet, AdSetBuilder,
  NewsletterSentLog, NewsletterSentLogBuilder,
  Ad, AdBuilder,
  ReportSettings, ReportSettingsBuilder,
  OrderCompletionRequest, OrderCompletionRequestBuilder,
  OrderCompletionSchedulerTask, OrderCompletionSchedulerTaskBuilder,
  OrderCompletionTask, OrderCompletionTaskBuilder,
  AutomatedMarketingSettings, AutomatedMarketingSettingsBuilder,
  PartnerApp, PartnerAppBuilder,
  PartnerAppNewsletterSettings, PartnerAppNewsletterSettingsBuilder,
  HomePageParams, HomePageParamsBuilder,
  OrderArtifactsComponent, OrderArtifactsComponentBuilder,
  InvoiceRetryRequest, InvoiceRetryRequestBuilder,
  InvoiceSubscriptionRequest, InvoiceSubscriptionRequestBuilder,
  ThirdPartyEventComponent, ThirdPartyEventComponentBuilder,
  TicketSettings, TicketSettingsBuilder,
  TicketCapacityGroup, TicketCapacityGroupBuilder,
  EventTicketCapacityGroups, EventTicketCapacityGroupsBuilder,
  CalendarEventBookingProtocol, CalendarEventBookingProtocolBuilder,
  TicketsAndProductsEventBookingProtocol, TicketsAndProductsEventBookingProtocolBuilder,
  TicketAsPassEventBookingProtocol, TicketAsPassEventBookingProtocolBuilder,
  TicketsOnlyEventBookingProtocol, TicketsOnlyEventBookingProtocolBuilder,
  VouchersOnlyEventBookingProtocol, VouchersOnlyEventBookingProtocolBuilder,
  BusinessBrevoTemplate, BusinessBrevoTemplateBuilder,
  SendProductOrderEmailSideEffect, SendProductOrderEmailSideEffectBuilder,
  RedirectAfterPaymentSideEffect, RedirectAfterPaymentSideEffectBuilder,
  DeferOrderCompletionSideEffect, DeferOrderCompletionSideEffectBuilder,
  CreateOpenAccessPassFromTicketSideEffect, CreateOpenAccessPassFromTicketSideEffectBuilder,
  SendOnlyPaymentConfirmationSideEffect, SendOnlyPaymentConfirmationSideEffectBuilder,
  CreateOpenTicketPassSideEffect, CreateOpenTicketPassSideEffectBuilder,
  CreateTicketGiftCardSideEffect, CreateTicketGiftCardSideEffectBuilder,
  CreateSingleOpenAccessPassSideEffect, CreateSingleOpenAccessPassSideEffectBuilder,
  CreateMultiOpenAccessPassSideEffect, CreateMultiOpenAccessPassSideEffectBuilder,
  SeatStateStatistics, SeatStateStatisticsBuilder,
  FormSubmission, FormSubmissionBuilder,
  TextFormSubmissionAnswer, TextFormSubmissionAnswerBuilder,
  OptionSelectFormSubmissionAnswer, OptionSelectFormSubmissionAnswerBuilder,
  DateTimeFormSubmissionAnswer, DateTimeFormSubmissionAnswerBuilder,
  BooleanFormSubmissionAnswer, BooleanFormSubmissionAnswerBuilder,
  FormFieldOption, FormFieldOptionBuilder,
  FormSubmissionsComponent, FormSubmissionsComponentBuilder,
  FormQuestionsComponent, FormQuestionsComponentBuilder,
  AlreadySentEvent, AlreadySentEventBuilder,
  PaymentProtocol, PaymentProtocolBuilder,
  PaymentProtocolComponent, PaymentProtocolComponentBuilder,
  PaymentProtocolSettings, PaymentProtocolSettingsBuilder,
  GenerateProductQrSideEffect, GenerateProductQrSideEffectBuilder,
  GenerateProductPdfSideEffect, GenerateProductPdfSideEffectBuilder,
  OkeokeProductsOutboundWebhookProtocol,
  OkeokeProductsOutboundWebhookProtocolBuilder,
  OutboundWebhookSideEffect,
  OutboundWebhookSideEffectBuilder,
  BackstagePos, BackstagePosBuilder,
  GenericProductQrObjectReference, GenericProductQrObjectReferenceBuilder,
  GenericSellingEventBookingProtocol, GenericSellingEventBookingProtocolBuilder,
  ObjectListRenderOrder, ObjectListRenderOrderBuilder,
  GenericOrder, GenericOrderBuilder,
  GenericOrderDonationEntry, GenericOrderDonationEntryBuilder,
  GenericOrderTicketEntry, GenericOrderTicketEntryBuilder,
  GenericOrderProductEntry, GenericOrderProductEntryBuilder,
  GenericOrderVoucherEntry, GenericOrderVoucherEntryBuilder,
  OnlineTransactionDetails, OnlineTransactionDetailsBuilder,
  DonationCartItemDto, DonationCartItemDtoBuilder,
  OfflineEventCartEntryDto, OfflineEventCartEntryDtoBuilder,
  GenericOrderCreatedEntry, GenericOrderCreatedEntryBuilder,
  GenericOrderCompletedEntry, GenericOrderCompletedEntryBuilder,
  GenericOrderAbortedEntry, GenericOrderAbortedEntryBuilder,
  GenericOrderRefundedEntry, GenericOrderRefundedEntryBuilder,
  GenericOrderCanceledEntry, GenericOrderCanceledEntryBuilder,
  GenericOrderTicketSupplementEntry, GenericOrderTicketSupplementEntryBuilder,
  TicketSupplementRef, TicketSupplementRefBuilder,
  OfflineGenericOrderCreatedEvent, OfflineGenericOrderCreatedEventBuilder,
  OpenAccessPassDetails, OpenAccessPassDetailsBuilder,
  OverrideNameComponent, OverrideNameComponentBuilder,
  OfflineInvoicingDetails, OfflineInvoicingDetailsBuilder,
  LegacyReceiptGroup, LegacyReceiptGroupBuilder,
  CreateReceiptSideEffect, CreateReceiptSideEffectBuilder,
  OfflineTransactionDetails, OfflineTransactionDetailsBuilder,
  GenericOrderEntryCanceledEvent, GenericOrderEntryCanceledEventBuilder,
  GenericSeatedEventTicketSwapEntry, GenericSeatedEventTicketSwapEntryBuilder,
  OfflineReceipt, OfflineReceiptBuilder,
  OfflineReceiptAction, OfflineReceiptActionBuilder,
  OfflineReceiptGroup, OfflineReceiptGroupBuilder,
  CustomerLocation, CustomerLocationBuilder,
  BirthDate, BirthDateBuilder,
  CartCustomerDto, CartCustomerDtoBuilder,
  OfflineProductCartDto, OfflineProductCartDtoBuilder,
  GenericOrderGiftCardEntry, GenericOrderGiftCardEntryBuilder,
  GiftCardSellingSettings, GiftCardSellingSettingsBuilder,
  CreateMultiGiftCardSideEffect, CreateMultiGiftCardSideEffectBuilder,
} from './data-models.js';
import { DatabaseIdGenerator } from './utility/database-id-generator.js';
import { isNotNullOrUndefined } from './utility/null-safety.js';

function getDefaultBuilders(): Map<string, unknown> {
  const builders = new Map<string, unknown>();
  builders.set(ConnectionStatusPayload.TYPE_ID, new ConnectionStatusPayloadBuilder());
  builders.set(WhisperPayload.TYPE_ID, new WhisperPayloadBuilder());
  builders.set(ErrorPayload.TYPE_ID, new ErrorPayloadBuilder());
  builders.set(BusinessChangedPayload.TYPE_ID, new BusinessChangedPayloadBuilder());
  builders.set(SeatSelectionRequestPayload.TYPE_ID, new SeatSelectionRequestPayloadBuilder());
  builders.set(SeatSelectionChangedPayload.TYPE_ID, new SeatSelectionChangedPayloadBuilder());
  builders.set(SeatPreviewState.TYPE_ID, new SeatPreviewStateBuilder());
  builders.set(SeatPreviewStatesChangedPayload.TYPE_ID, new SeatPreviewStatesChangedPayloadBuilder());
  builders.set(SeatWithTicketTemplateDto.TYPE_ID, new SeatWithTicketTemplateDtoBuilder());
  builders.set(CartDiscountDto.TYPE_ID, new CartDiscountDtoBuilder());
  builders.set(DiscountChangedPayload.TYPE_ID, new DiscountChangedPayloadBuilder());
  builders.set(InitializePreviewResponsePayload.TYPE_ID, new InitializePreviewResponsePayloadBuilder());
  builders.set(Ad.TYPE_ID, new AdBuilder());
  builders.set(AdAccount.TYPE_ID, new AdAccountBuilder());
  builders.set(AdAccountDto.TYPE_ID, new AdAccountDtoBuilder());
  builders.set(AdCredit.TYPE_ID, new AdCreditBuilder());
  builders.set(AlreadySentEvent.TYPE_ID, new AlreadySentEventBuilder());
  builders.set(AutomatedMarketingSettings.TYPE_ID, new AutomatedMarketingSettingsBuilder());
  builders.set(OrderCompletionRequest.TYPE_ID, new OrderCompletionRequestBuilder());
  builders.set(OrderCompletionSchedulerTask.TYPE_ID, new OrderCompletionSchedulerTaskBuilder());
  builders.set(OrderCompletionTask.TYPE_ID, new OrderCompletionTaskBuilder());
  builders.set(ReportSettings.TYPE_ID, new ReportSettingsBuilder());
  builders.set(AddEventToSeatedOpenAccessProtocol.TYPE_ID, new AddEventToSeatedOpenAccessProtocolBuilder());
  builders.set(Address.TYPE_ID, new AddressBuilder());
  builders.set(AddressComponent.TYPE_ID, new AddressComponentBuilder());
  builders.set(AdSet.TYPE_ID, new AdSetBuilder());
  builders.set(NewsletterSentLog.TYPE_ID, new NewsletterSentLogBuilder());
  builders.set(AdvertLocationComponent.TYPE_ID, new AdvertLocationComponentBuilder());
  builders.set(AdvertProfileComponent.TYPE_ID, new AdvertProfileComponentBuilder());
  builders.set(AnalyticsCartDto.TYPE_ID, new AnalyticsCartDtoBuilder());
  builders.set(AnalyticsCartItemDto.TYPE_ID, new AnalyticsCartItemDtoBuilder());
  builders.set(AnalyticsSettingsComponent.TYPE_ID, new AnalyticsSettingsComponentBuilder());
  builders.set(ArtificialSeatLockingComponent.TYPE_ID, new ArtificialSeatLockingComponentBuilder());
  builders.set(ArtificialSeatLockingSettings.TYPE_ID, new ArtificialSeatLockingSettingsBuilder());
  builders.set(ArtistPageInfo.TYPE_ID, new ArtistPageInfoBuilder());
  builders.set(ArtistProfile.TYPE_ID, new ArtistProfileBuilder());
  builders.set(AuditLogEntryDto.TYPE_ID, new AuditLogEntryDtoBuilder());
  builders.set(BackstageEvent.TYPE_ID, new BackstageEventBuilder());
  builders.set(BackstageEventComponent.TYPE_ID, new BackstageEventComponentBuilder());
  builders.set(BackstageTicket.TYPE_ID, new BackstageTicketBuilder());
  builders.set(BackstageTicketComponent.TYPE_ID, new BackstageTicketComponentBuilder());
  builders.set(BillingAccount.TYPE_ID, new BillingAccountBuilder());
  builders.set(BillingDetailsComponent.TYPE_ID, new BillingDetailsComponentBuilder());
  builders.set(BillingoInvoicingProtocol.TYPE_ID, new BillingoInvoicingProtocolBuilder());
  builders.set(BillingProfile.TYPE_ID, new BillingProfileBuilder());
  builders.set(BlacklistComponent.TYPE_ID, new BlacklistComponentBuilder());
  builders.set(BookNowComponent.TYPE_ID, new BookNowComponentBuilder());
  builders.set(BooleanFormInputField.TYPE_ID, new BooleanFormInputFieldBuilder());
  builders.set(BrandPageInfo.TYPE_ID, new BrandPageInfoBuilder());
  builders.set(BrandProfile.TYPE_ID, new BrandProfileBuilder());
  builders.set(Building.TYPE_ID, new BuildingBuilder());
  builders.set(BusinessAppearanceSettings.TYPE_ID, new BusinessAppearanceSettingsBuilder());
  builders.set(BusinessAppearanceSettingsComponent.TYPE_ID, new BusinessAppearanceSettingsComponentBuilder());
  builders.set(BusinessBrevoTemplate.TYPE_ID, new BusinessBrevoTemplateBuilder());
  builders.set(BusinessClassificationComponent.TYPE_ID, new BusinessClassificationComponentBuilder());
  builders.set(BusinessDeletedEvent.TYPE_ID, new BusinessDeletedEventBuilder());
  builders.set(BusinessDetailsSettings.TYPE_ID, new BusinessDetailsSettingsBuilder());
  builders.set(ModuleSettings.TYPE_ID, new ModuleSettingsBuilder());
  builders.set(BusinessHours.TYPE_ID, new BusinessHoursBuilder());
  builders.set(BusinessHoursComponent.TYPE_ID, new BusinessHoursComponentBuilder());
  builders.set(BusinessHoursDay.TYPE_ID, new BusinessHoursDayBuilder());
  builders.set(DonationSettings.TYPE_ID, new DonationSettingsBuilder());
  builders.set(BusinessLevelMarketingInfo.TYPE_ID, new BusinessLevelMarketingInfoBuilder());
  builders.set(BusinessLevelMarketingSettings.TYPE_ID, new BusinessLevelMarketingSettingsBuilder());
  builders.set(BusinessLevelMarketingSubscriber.TYPE_ID, new BusinessLevelMarketingSubscriberBuilder());
  builders.set(BusinessLevelMarketingSubscriptionRequest.TYPE_ID, new BusinessLevelMarketingSubscriptionRequestBuilder());
  builders.set(BusinessLocationComponent.TYPE_ID, new BusinessLocationComponentBuilder());
  builders.set(BusinessMembership.TYPE_ID, new BusinessMembershipBuilder());
  builders.set(BusinessModule.TYPE_ID, new BusinessModuleBuilder());
  builders.set(BusinessPrivacySettings.TYPE_ID, new BusinessPrivacySettingsBuilder());
  builders.set(BusinessPrivacySettingsComponent.TYPE_ID, new BusinessPrivacySettingsComponentBuilder());
  builders.set(BusinessProfile.TYPE_ID, new BusinessProfileBuilder());
  builders.set(BusinessPromoCode.TYPE_ID, new BusinessPromoCodeBuilder());
  builders.set(BusinessRatingComponent.TYPE_ID, new BusinessRatingComponentBuilder());
  builders.set(BusinessRatingUpdatedEvent.TYPE_ID, new BusinessRatingUpdatedEventBuilder());
  builders.set(BusinessRoute.TYPE_ID, new BusinessRouteBuilder());
  builders.set(BusinessSettings.TYPE_ID, new BusinessSettingsBuilder());
  builders.set(BusinessSettingsComponent.TYPE_ID, new BusinessSettingsComponentBuilder());
  builders.set(BusinessShortCode.TYPE_ID, new BusinessShortCodeBuilder());
  builders.set(BusinessUpdatedEvent.TYPE_ID, new BusinessUpdatedEventBuilder());
  builders.set(BuyTicketComponent.TYPE_ID, new BuyTicketComponentBuilder());
  builders.set(CalendarBookingSettings.TYPE_ID, new CalendarBookingSettingsBuilder());
  builders.set(CalendarBookingSettingsComponent.TYPE_ID, new CalendarBookingSettingsComponentBuilder());
  builders.set(CalendarBreak.TYPE_ID, new CalendarBreakBuilder());
  builders.set(CalendarEntryAbortedEvent.TYPE_ID, new CalendarEntryAbortedEventBuilder());
  builders.set(CalendarEntryCanceledEvent.TYPE_ID, new CalendarEntryCanceledEventBuilder());
  builders.set(CalendarEntryComponent.TYPE_ID, new CalendarEntryComponentBuilder());
  builders.set(CalendarEntryCreatedEvent.TYPE_ID, new CalendarEntryCreatedEventBuilder());
  builders.set(CalendarEntryGroupCanceledEvent.TYPE_ID, new CalendarEntryGroupCanceledEventBuilder());
  builders.set(CalendarEntryRescheduledEvent.TYPE_ID, new CalendarEntryRescheduledEventBuilder());
  builders.set(CalendarEntryUpdatedEvent.TYPE_ID, new CalendarEntryUpdatedEventBuilder());
  builders.set(CalendarNote.TYPE_ID, new CalendarNoteBuilder());
  builders.set(CalendarOrderItem.TYPE_ID, new CalendarOrderItemBuilder());
  builders.set(Campaign.TYPE_ID, new CampaignBuilder());
  builders.set(CancelNotConfirmedEvent.TYPE_ID, new CancelNotConfirmedEventBuilder());
  builders.set(CancelNotificationEvent.TYPE_ID, new CancelNotificationEventBuilder());
  builders.set(CapacityRoom.TYPE_ID, new CapacityRoomBuilder());
  builders.set(CapacityRange.TYPE_ID, new CapacityRangeBuilder());
  builders.set(CheckoutRequestResult.TYPE_ID, new CheckoutRequestResultBuilder());
  builders.set(EventCategoryPrompt.TYPE_ID, new EventCategoryPromptBuilder());
  builders.set(ClientCacheRefreshEvent.TYPE_ID, new ClientCacheRefreshEventBuilder());
  builders.set(ClientCreatedEvent.TYPE_ID, new ClientCreatedEventBuilder());
  builders.set(ClientDeletedEvent.TYPE_ID, new ClientDeletedEventBuilder());
  builders.set(ClientInviteCode.TYPE_ID, new ClientInviteCodeBuilder());
  builders.set(ClientInviteComponent.TYPE_ID, new ClientInviteComponentBuilder());
  builders.set(ClientNoteComponent.TYPE_ID, new ClientNoteComponentBuilder());
  builders.set(ClientsImportedEvent.TYPE_ID, new ClientsImportedEventBuilder());
  builders.set(ClientUpdatedEvent.TYPE_ID, new ClientUpdatedEventBuilder());
  builders.set(CloudNotification.TYPE_ID, new CloudNotificationBuilder());
  builders.set(ClusteredSchedulingSettings.TYPE_ID, new ClusteredSchedulingSettingsBuilder());
  builders.set(CollaboratorEventAccessComponent.TYPE_ID, new CollaboratorEventAccessComponentBuilder());
  builders.set(CollaboratorProfile.TYPE_ID, new CollaboratorProfileBuilder());
  builders.set(CommonPrompt.TYPE_ID, new CommonPromptBuilder());
  builders.set(CompactAppointmentSettings.TYPE_ID, new CompactAppointmentSettingsBuilder());
  builders.set(ContactComponent.TYPE_ID, new ContactComponentBuilder());
  builders.set(Consent.TYPE_ID, new ConsentBuilder());
  builders.set(ContactDetails.TYPE_ID, new ContactDetailsBuilder());
  builders.set(CoverImageComponent.TYPE_ID, new CoverImageComponentBuilder());
  builders.set(CurrencySettings.TYPE_ID, new CurrencySettingsBuilder());
  builders.set(CurrencySettingsComponent.TYPE_ID, new CurrencySettingsComponentBuilder());
  builders.set(CustomerAccount.TYPE_ID, new CustomerAccountBuilder());
  builders.set(CustomerAuthDetails.TYPE_ID, new CustomerAuthDetailsBuilder());
  builders.set(CustomerCreatedEvent.TYPE_ID, new CustomerCreatedEventBuilder());
  builders.set(CustomerLocationComponent.TYPE_ID, new CustomerLocationComponentBuilder());
  builders.set(CustomerProfile.TYPE_ID, new CustomerProfileBuilder());
  builders.set(CustomerSubscription.TYPE_ID, new CustomerSubscriptionBuilder());
  builders.set(CustomerTrackingComponent.TYPE_ID, new CustomerTrackingComponentBuilder());
  builders.set(CustomerUpdatedEvent.TYPE_ID, new CustomerUpdatedEventBuilder());
  builders.set(CustomImageInfoComponent.TYPE_ID, new CustomImageInfoComponentBuilder());
  builders.set(CustomInfo.TYPE_ID, new CustomInfoBuilder());
  builders.set(CustomInfoComponent.TYPE_ID, new CustomInfoComponentBuilder());
  builders.set(CustomNameComponent.TYPE_ID, new CustomNameComponentBuilder());
  builders.set(DailyGenericIncomeStats.TYPE_ID, new DailyGenericIncomeStatsBuilder());
  builders.set(DailyIncomeStats.TYPE_ID, new DailyIncomeStatsBuilder());
  builders.set(DailySchedule.TYPE_ID, new DailyScheduleBuilder());
  builders.set(DailyStatistics.TYPE_ID, new DailyStatisticsBuilder());
  builders.set(DailyTicketSalesStats.TYPE_ID, new DailyTicketSalesStatsBuilder());
  builders.set(DailyTicketStats.TYPE_ID, new DailyTicketStatsBuilder());
  builders.set(DateFormatComponent.TYPE_ID, new DateFormatComponentBuilder());
  builders.set(DateSpan.TYPE_ID, new DateSpanBuilder());
  builders.set(DateSpanComponent.TYPE_ID, new DateSpanComponentBuilder());
  builders.set(DateTimeFormInputField.TYPE_ID, new DateTimeFormInputFieldBuilder());
  builders.set(DayOfYear.TYPE_ID, new DayOfYearBuilder());
  builders.set(DifficultyComponent.TYPE_ID, new DifficultyComponentBuilder());
  builders.set(Discount.TYPE_ID, new DiscountBuilder());
  builders.set(DiscoverContent.TYPE_ID, new DiscoverContentBuilder());
  builders.set(DiscoverPageInfo.TYPE_ID, new DiscoverPageInfoBuilder());
  builders.set(DesktopBridgeInfo.TYPE_ID, new DesktopBridgeInfoBuilder());
  builders.set(DistanceComponent.TYPE_ID, new DistanceComponentBuilder());
  builders.set(DonationPlaceholder.TYPE_ID, new DonationPlaceholderBuilder());
  builders.set(DownToPricePromoCodeProtocol.TYPE_ID, new DownToPricePromoCodeProtocolBuilder());
  builders.set(DurationComponent.TYPE_ID, new DurationComponentBuilder());
  builders.set(DurationRange.TYPE_ID, new DurationRangeBuilder());
  builders.set(DynamicApplicationFeeProtocol.TYPE_ID, new DynamicApplicationFeeProtocolBuilder());
  builders.set(DynamicPricingSettings.TYPE_ID, new DynamicPricingSettingsBuilder());
  builders.set(DynamicPricingSettingsComponent.TYPE_ID, new DynamicPricingSettingsComponentBuilder());
  builders.set(ElevationComponent.TYPE_ID, new ElevationComponentBuilder());
  builders.set(EmailVerificationCode.TYPE_ID, new EmailVerificationCodeBuilder());
  builders.set(EventArchivedEvent.TYPE_ID, new EventArchivedEventBuilder());
  builders.set(EventClassificationComponent.TYPE_ID, new EventClassificationComponentBuilder());
  builders.set(EventCreatedEvent.TYPE_ID, new EventCreatedEventBuilder());
  builders.set(EventProduction.TYPE_ID, new EventProductionBuilder());
  builders.set(EventMembership.TYPE_ID, new EventMembershipBuilder());
  builders.set(EventOpenAccessProtocol.TYPE_ID, new EventOpenAccessProtocolBuilder());
  builders.set(EventPrivacySettingsComponent.TYPE_ID, new EventPrivacySettingsComponentBuilder());
  builders.set(EventProfile.TYPE_ID, new EventProfileBuilder());
  builders.set(EventAssociations.TYPE_ID, new EventAssociationsBuilder());
  builders.set(EventProfileAssociations.TYPE_ID, new EventProfileAssociationsBuilder());
  builders.set(EventPromoCode.TYPE_ID, new EventPromoCodeBuilder());
  builders.set(EventSeatingState.TYPE_ID, new EventSeatingStateBuilder());
  builders.set(EventSeatSelectionLock.TYPE_ID, new EventSeatSelectionLockBuilder());
  builders.set(EventShortCode.TYPE_ID, new EventShortCodeBuilder());
  builders.set(EventTicket.TYPE_ID, new EventTicketBuilder());
  builders.set(EventTicketOrder.TYPE_ID, new EventTicketOrderBuilder());
  builders.set(EventUpdatedEvent.TYPE_ID, new EventUpdatedEventBuilder());
  builders.set(FeaturedContactOptionsComponent.TYPE_ID, new FeaturedContactOptionsComponentBuilder());
  builders.set(FeaturedMetadata.TYPE_ID, new FeaturedMetadataBuilder());
  builders.set(FeaturedOption.TYPE_ID, new FeaturedOptionBuilder());
  builders.set(FeaturedTagComponent.TYPE_ID, new FeaturedTagComponentBuilder());
  builders.set(Fee.TYPE_ID, new FeeBuilder());
  builders.set(FeeRange.TYPE_ID, new FeeRangeBuilder());
  builders.set(FeeSettingsComponent.TYPE_ID, new FeeSettingsComponentBuilder());
  builders.set(FestivalLikes.TYPE_ID, new FestivalLikesBuilder());
  builders.set(FestivalRaffleEntry.TYPE_ID, new FestivalRaffleEntryBuilder());
  builders.set(FileReference.TYPE_ID, new FileReferenceBuilder());
  builders.set(FixedPromoCodeProtocol.TYPE_ID, new FixedPromoCodeProtocolBuilder());
  builders.set(FlexibleServiceDuration.TYPE_ID, new FlexibleServiceDurationBuilder());
  builders.set(FlexibleServiceDurationComponent.TYPE_ID, new FlexibleServiceDurationComponentBuilder());
  builders.set(FormComponent.TYPE_ID, new FormComponentBuilder());
  builders.set(GalleryComponent.TYPE_ID, new GalleryComponentBuilder());
  builders.set(GateOpenTimeComponent.TYPE_ID, new GateOpenTimeComponentBuilder());
  builders.set(GenericPermissionMatrix.TYPE_ID, new GenericPermissionMatrixBuilder());
  builders.set(GeoCoordinates.TYPE_ID, new GeoCoordinatesBuilder());
  builders.set(GroupOrderComponent.TYPE_ID, new GroupOrderComponentBuilder());
  builders.set(GroupReservation.TYPE_ID, new GroupReservationBuilder());
  builders.set(GuestAccount.TYPE_ID, new GuestAccountBuilder());
  builders.set(GymAccessProtocol.TYPE_ID, new GymAccessProtocolBuilder());
  builders.set(GymPassOrder.TYPE_ID, new GymPassOrderBuilder());
  builders.set(GymPassPresence.TYPE_ID, new GymPassPresenceBuilder());
  builders.set(HealthAndSafetyComponent.TYPE_ID, new HealthAndSafetyComponentBuilder());
  builders.set(HealthAndSafetySettings.TYPE_ID, new HealthAndSafetySettingsBuilder());
  builders.set(HomePageInfo.TYPE_ID, new HomePageInfoBuilder());
  builders.set(ImageSize.TYPE_ID, new ImageSizeBuilder());
  builders.set(IntentComponent.TYPE_ID, new IntentComponentBuilder());
  builders.set(Invoice.TYPE_ID, new InvoiceBuilder());
  builders.set(InvoiceAction.TYPE_ID, new InvoiceActionBuilder());
  builders.set(InvoiceGroup.TYPE_ID, new InvoiceGroupBuilder());
  builders.set(InvoiceSettingsComponent.TYPE_ID, new InvoiceSettingsComponentBuilder());
  builders.set(OnlineInvoicingDetails.TYPE_ID, new OnlineInvoicingDetailsBuilder());
  builders.set(KeyValueStore.TYPE_ID, new KeyValueStoreBuilder());
  builders.set(LabelComponent.TYPE_ID, new LabelComponentBuilder());
  builders.set(LandscapeRatingComponent.TYPE_ID, new LandscapeRatingComponentBuilder());
  builders.set(LastActivityComponent.TYPE_ID, new LastActivityComponentBuilder());
  builders.set(LegacyBillingDetailsComponent.TYPE_ID, new LegacyBillingDetailsComponentBuilder());
  builders.set(LegacyBookNowComponent.TYPE_ID, new LegacyBookNowComponentBuilder());
  builders.set(LegacyBusinessPaymentComponent.TYPE_ID, new LegacyBusinessPaymentComponentBuilder());
  builders.set(LegacyCalendarSnapshot.TYPE_ID, new LegacyCalendarSnapshotBuilder());
  builders.set(LegacyConsentComponent.TYPE_ID, new LegacyConsentComponentBuilder());
  builders.set(LegacyEventPromoCode.TYPE_ID, new LegacyEventPromoCodeBuilder());
  builders.set(LegacyInvoiceDetails.TYPE_ID, new LegacyInvoiceDetailsBuilder());
  builders.set(LegacyLocalizedRichTextComponent.TYPE_ID, new LegacyLocalizedRichTextComponentBuilder());
  builders.set(LegacyPointOfInterestItem.TYPE_ID, new LegacyPointOfInterestItemBuilder());
  builders.set(LegacyPointOfInterestItemsComponent.TYPE_ID, new LegacyPointOfInterestItemsComponentBuilder());
  builders.set(LegacyPriceBasedSerialNumberPool.TYPE_ID, new LegacyPriceBasedSerialNumberPoolMigratingBuilder());
  builders.set(LegacyResponsiveImageComponent.TYPE_ID, new LegacyResponsiveImageComponentBuilder());
  builders.set(LegacySeatingLayout.TYPE_ID, new LegacySeatingLayoutBuilder());
  builders.set(LegacySeatingSettingsComponent.TYPE_ID, new LegacySeatingSettingsComponentBuilder());
  builders.set(LegacyStaffRoleComponent.TYPE_ID, new LegacyStaffRoleComponentBuilder());
  builders.set(LegacyTicketBasedSerialNumberPool.TYPE_ID, new LegacyTicketBasedSerialNumberPoolMigratingBuilder());
  builders.set(LegacyTicketGiftCard.TYPE_ID, new LegacyTicketGiftCardBuilder());
  builders.set(LegacyTicketPool.TYPE_ID, new LegacyTicketPoolBuilder());
  builders.set(LegacyTicketSeasonPass.TYPE_ID, new LegacyTicketSeasonPassBuilder());
  builders.set(LimitedTimeAccessProtocol.TYPE_ID, new LimitedTimeAccessProtocolBuilder());
  builders.set(LimitedUseAccessProtocol.TYPE_ID, new LimitedUseAccessProtocolBuilder());
  builders.set(FlexiblePassProtocol.TYPE_ID, new FlexiblePassProtocolBuilder());
  builders.set(Locality.TYPE_ID, new LocalityBuilder());
  builders.set(LocalizationSettings.TYPE_ID, new LocalizationSettingsBuilder());
  builders.set(LocalizedDescriptionComponent.TYPE_ID, new LocalizedDescriptionComponentBuilder());
  builders.set(LocalizedNameComponent.TYPE_ID, new LocalizedNameComponentBuilder());
  builders.set(LocalizedFileReference.TYPE_ID, new LocalizedFileReferenceBuilder());
  builders.set(LocalizedPhotoCollection.TYPE_ID, new LocalizedPhotoCollectionBuilder());
  builders.set(LocalizedPhotoReference.TYPE_ID, new LocalizedPhotoReferenceBuilder());
  builders.set(LocalizedProfilePhotosComponent.TYPE_ID, new LocalizedProfilePhotosComponentBuilder());
  builders.set(LocalizedRichDescription.TYPE_ID, new LocalizedRichDescriptionBuilder());
  builders.set(LocalizedRichDescriptionComponent.TYPE_ID, new LocalizedRichDescriptionComponentBuilder());
  builders.set(LocalizedRichTextComponent.TYPE_ID, new LocalizedRichTextComponentBuilder());
  builders.set(LocalizedString.TYPE_ID, new LocalizedStringBuilder());
  builders.set(LocationComponent.TYPE_ID, new LocationComponentBuilder());
  builders.set(LocationHistory.TYPE_ID, new LocationHistoryBuilder());
  builders.set(MailchimpSettings.TYPE_ID, new MailchimpSettingsBuilder());
  builders.set(MailchimpSubscription.TYPE_ID, new MailchimpSubscriptionBuilder());
  builders.set(MailerliteSettings.TYPE_ID, new MailerliteSettingsBuilder());
  builders.set(MailerliteSubscription.TYPE_ID, new MailerliteSubscriptionBuilder());
  builders.set(MapLocation.TYPE_ID, new MapLocationBuilder());
  builders.set(MapViewComponent.TYPE_ID, new MapViewComponentBuilder());
  builders.set(MarketingConsent.TYPE_ID, new MarketingConsentBuilder());
  builders.set(MaxElevationComponent.TYPE_ID, new MaxElevationComponentBuilder());
  builders.set(MenuCategory.TYPE_ID, new MenuCategoryBuilder());
  builders.set(MenuComponent.TYPE_ID, new MenuComponentBuilder());
  builders.set(MenuItem.TYPE_ID, new MenuItemBuilder());
  builders.set(MonthlyCalendarSnapshot.TYPE_ID, new MonthlyCalendarSnapshotBuilder());
  builders.set(MonthlySalesIncomeSummary.TYPE_ID, new MonthlySalesIncomeSummaryBuilder());
  builders.set(MonthlySalesSummary.TYPE_ID, new MonthlySalesSummaryBuilder());
  builders.set(MonthlyStaffStatistics.TYPE_ID, new MonthlyStaffStatisticsBuilder());
  builders.set(MonthOfYear.TYPE_ID, new MonthOfYearBuilder());
  builders.set(NewsContent.TYPE_ID, new NewsContentBuilder());
  builders.set(NewsPost.TYPE_ID, new NewsPostBuilder());
  builders.set(NFCPassRef.TYPE_ID, new NFCPassRefBuilder());
  builders.set(NFCWritePayload.TYPE_ID, new NFCWritePayloadBuilder());
  builders.set(NoteComponent.TYPE_ID, new NoteComponentBuilder());
  builders.set(NTAKAccountSettings.TYPE_ID, new NTAKAccountSettingsBuilder());
  builders.set(NTAKCustomerDetails.TYPE_ID, new NTAKCustomerDetailsBuilder());
  builders.set(NTAKCustomerDetailsComponent.TYPE_ID, new NTAKCustomerDetailsComponentBuilder());
  builders.set(NTAKEventSettingsComponent.TYPE_ID, new NTAKEventSettingsComponentBuilder());
  builders.set(NTAKProgramSettings.TYPE_ID, new NTAKProgramSettingsBuilder());
  builders.set(NTAKServiceLocation.TYPE_ID, new NTAKServiceLocationBuilder());
  builders.set(NTAKSettingsComponent.TYPE_ID, new NTAKSettingsComponentBuilder());
  builders.set(NTAKTicketSettings.TYPE_ID, new NTAKTicketSettingsBuilder());
  builders.set(NTAKTicketSettingsComponent.TYPE_ID, new NTAKTicketSettingsComponentBuilder());
  builders.set(Nutrients.TYPE_ID, new NutrientsBuilder());
  builders.set(OccasionsComponent.TYPE_ID, new OccasionsComponentBuilder());
  builders.set(ObjectListRenderOrder.TYPE_ID, new ObjectListRenderOrderBuilder());
  builders.set(OfflineEventCartDto.TYPE_ID, new OfflineEventCartDtoBuilder());
  builders.set(OfflineEventTicketOrderAbortedEntry.TYPE_ID, new OfflineEventTicketOrderAbortedEntryBuilder());
  builders.set(OfflineEventTicketOrderCompletedEntry.TYPE_ID, new OfflineEventTicketOrderCompletedEntryBuilder());
  builders.set(OfflineEventTicketOrderCreatedEntry.TYPE_ID, new OfflineEventTicketOrderCreatedEntryBuilder());
  builders.set(OfflineEventTicketOrderModifiedEntry.TYPE_ID, new OfflineEventTicketOrderModifiedEntryBuilder());
  builders.set(OfflineEventTicketOrderPaymentMethodChangedEntry.TYPE_ID, new OfflineEventTicketOrderPaymentMethodChangedEntryBuilder());
  builders.set(AdminOrderPaymentMethodChangedEntry.TYPE_ID, new AdminOrderPaymentMethodChangedEntryBuilder());
  builders.set(OfflinePaymentDetails.TYPE_ID, new OfflinePaymentDetailsBuilder());
  builders.set(OfflineProductOrderCreatedEvent.TYPE_ID, new OfflineProductOrderCreatedEventBuilder());
  builders.set(OfflineTicketOrderCreatedEvent.TYPE_ID, new OfflineTicketOrderCreatedEventBuilder());
  builders.set(OnlineCalendarOrder.TYPE_ID, new OnlineCalendarOrderBuilder());
  builders.set(OnlineCartDto.TYPE_ID, new OnlineCartDtoBuilder());
  builders.set(OnlineEventPassOrder.TYPE_ID, new OnlineEventPassOrderBuilder());
  builders.set(OnlineEventPassOrderCreatedEntry.TYPE_ID, new OnlineEventPassOrderCreatedEntryBuilder());
  builders.set(OnlineEventTicketOrder.TYPE_ID, new OnlineEventTicketOrderBuilder());
  builders.set(OnlineEventTicketOrderAbortedEntry.TYPE_ID, new OnlineEventTicketOrderAbortedEntryBuilder());
  builders.set(OnlineEventTicketOrderCanceledEntry.TYPE_ID, new OnlineEventTicketOrderCanceledEntryBuilder());
  builders.set(OnlineEventTicketOrderCompletedEntry.TYPE_ID, new OnlineEventTicketOrderCompletedEntryBuilder());
  builders.set(OnlineEventTicketOrderCreatedEntry.TYPE_ID, new OnlineEventTicketOrderCreatedEntryBuilder());
  builders.set(OnlineEventTicketOrderItem.TYPE_ID, new OnlineEventTicketOrderItemBuilder());
  builders.set(OnlineEventTicketOrderRefundedEntry.TYPE_ID, new OnlineEventTicketOrderRefundedEntryBuilder());
  builders.set(OnlinePaymentDetails.TYPE_ID, new OnlinePaymentDetailsBuilder());
  builders.set(OnlineProductOrder.TYPE_ID, new OnlineProductOrderBuilder());
  builders.set(OnlineProductOrderAbortedEntry.TYPE_ID, new OnlineProductOrderAbortedEntryBuilder());
  builders.set(OnlineProductOrderCanceledEntry.TYPE_ID, new OnlineProductOrderCanceledEntryBuilder());
  builders.set(OnlineProductOrderCanceledEvent.TYPE_ID, new OnlineProductOrderCanceledEventBuilder());
  builders.set(OnlineProductOrderCompletedEntry.TYPE_ID, new OnlineProductOrderCompletedEntryBuilder());
  builders.set(OnlineProductOrderCreatedEntry.TYPE_ID, new OnlineProductOrderCreatedEntryBuilder());
  builders.set(OnlineProductOrderRefundedEntry.TYPE_ID, new OnlineProductOrderRefundedEntryBuilder());
  builders.set(OnLocationPaymentComponent.TYPE_ID, new OnLocationPaymentComponentBuilder());
  builders.set(OpenAccessPass.TYPE_ID, new OpenAccessPassBuilder());
  builders.set(OpenAccessPassBatchCreatedEvent.TYPE_ID, new OpenAccessPassBatchCreatedEventBuilder());
  builders.set(LegacyOpenAccessPassCartItemDto.TYPE_ID, new LegacyOpenAccessPassCartItemDtoBuilder());
  builders.set(OpenAccessPassComponent.TYPE_ID, new OpenAccessPassComponentBuilder());
  builders.set(OpenAccessPassCreatedEvent.TYPE_ID, new OpenAccessPassCreatedEventBuilder());
  builders.set(OpenAccessPassForSale.TYPE_ID, new OpenAccessPassForSaleBuilder());
  builders.set(OpenAccessPassPool.TYPE_ID, new OpenAccessPassPoolBuilder());
  builders.set(OpenAccessPassRenewalRequest.TYPE_ID, new OpenAccessPassRenewalRequestBuilder());
  builders.set(OpenAccessPassSeatLockUpdatedEvent.TYPE_ID, new OpenAccessPassSeatLockUpdatedEventBuilder());
  builders.set(OpenAccessPassTemplate.TYPE_ID, new OpenAccessPassTemplateBuilder());
  builders.set(OpenAccessPassTemplateCreatedEvent.TYPE_ID, new OpenAccessPassTemplateCreatedEventBuilder());
  builders.set(OpenAccessPassTemplateUpdatedEvent.TYPE_ID, new OpenAccessPassTemplateUpdatedEventBuilder());
  builders.set(OpenAccessPassUpdatedEvent.TYPE_ID, new OpenAccessPassUpdatedEventBuilder());
  builders.set(OpenAccessPassVariation.TYPE_ID, new OpenAccessPassVariationBuilder());
  builders.set(OpenAccessPassVariationDetails.TYPE_ID, new OpenAccessPassVariationDetailsBuilder());
  builders.set(OpenAccessScan.TYPE_ID, new OpenAccessScanBuilder());
  builders.set(OpenReservation.TYPE_ID, new OpenReservationBuilder());
  builders.set(OpenReservationDeletedEvent.TYPE_ID, new OpenReservationDeletedEventBuilder());
  builders.set(OpenTicketPass.TYPE_ID, new OpenTicketPassBuilder());
  builders.set(OpenTicketPassComponent.TYPE_ID, new OpenTicketPassComponentBuilder());
  builders.set(OptionSelectFormInputField.TYPE_ID, new OptionSelectFormInputFieldBuilder());
  builders.set(OrderCleanupRequest.TYPE_ID, new OrderCleanupRequestBuilder());
  builders.set(LegacyOrderHook.TYPE_ID, new LegacyOrderHookBuilder());
  builders.set(OrderReview.TYPE_ID, new OrderReviewBuilder());
  builders.set(LegacyOrderVoucherComponent.TYPE_ID, new LegacyOrderVoucherComponentBuilder());
  builders.set(Organization.TYPE_ID, new OrganizationBuilder());
  builders.set(OrganizerPageInfo.TYPE_ID, new OrganizerPageInfoBuilder());
  builders.set(OrganizerProfile.TYPE_ID, new OrganizerProfileBuilder());
  builders.set(OutdoorActivityComponent.TYPE_ID, new OutdoorActivityComponentBuilder());
  builders.set(OwnersComponent.TYPE_ID, new OwnersComponentBuilder());
  builders.set(PartnerAccount.TYPE_ID, new PartnerAccountBuilder());
  builders.set(PartnerApp.TYPE_ID, new PartnerAppBuilder());
  builders.set(PartnerAppNewsletterSettings.TYPE_ID, new PartnerAppNewsletterSettingsBuilder());
  builders.set(HomePageParams.TYPE_ID, new HomePageParamsBuilder());
  builders.set(LegacyPassCartDto.TYPE_ID, new LegacyPassCartDtoBuilder());
  builders.set(OfflineGiftCardCartDto.TYPE_ID, new OfflineGiftCardCartDtoBuilder());
  builders.set(GiftCardCartItemDto.TYPE_ID, new GiftCardCartItemDtoBuilder());
  builders.set(PassEventOverrideIntentComponent.TYPE_ID, new PassEventOverrideIntentComponentBuilder());
  builders.set(PassSeatingState.TYPE_ID, new PassSeatingStateBuilder());
  builders.set(PassSeatSelectionLock.TYPE_ID, new PassSeatSelectionLockBuilder());
  builders.set(PaymentAccount.TYPE_ID, new PaymentAccountBuilder());
  builders.set(PaymentAccountRef.TYPE_ID, new PaymentAccountRefBuilder());
  builders.set(PaymentIntent.TYPE_ID, new PaymentIntentBuilder());
  builders.set(PaymentRequestResult.TYPE_ID, new PaymentRequestResultBuilder());
  builders.set(LegacyPaymentSettings.TYPE_ID, new LegacyPaymentSettingsBuilder());
  builders.set(LegacyPaymentSettingsComponent.TYPE_ID, new LegacyPaymentSettingsComponentBuilder());
  builders.set(PercentagePromoCodeProtocol.TYPE_ID, new PercentagePromoCodeProtocolBuilder());
  builders.set(PersistenceOnlySettings.TYPE_ID, new PersistenceOnlySettingsBuilder());
  builders.set(PersistenceOnlySubscription.TYPE_ID, new PersistenceOnlySubscriptionBuilder());
  builders.set(PhoneCalendarOrder.TYPE_ID, new PhoneCalendarOrderBuilder());
  builders.set(PhoneContact.TYPE_ID, new PhoneContactBuilder());
  builders.set(PhotoCollection.TYPE_ID, new PhotoCollectionBuilder());
  builders.set(PhotoLOD.TYPE_ID, new PhotoLODBuilder());
  builders.set(PhotoReference.TYPE_ID, new PhotoReferenceBuilder());
  builders.set(Place.TYPE_ID, new PlaceBuilder());
  builders.set(PlaceComponent.TYPE_ID, new PlaceComponentBuilder());
  builders.set(PointOfInterestComponent.TYPE_ID, new PointOfInterestComponentBuilder());
  builders.set(PointOfInterestDistribution.TYPE_ID, new PointOfInterestDistributionBuilder());
  builders.set(PointOfInterestTagComponent.TYPE_ID, new PointOfInterestTagComponentBuilder());
  builders.set(PoiReview.TYPE_ID, new PoiReviewBuilder());
  builders.set(PoliciesSettings.TYPE_ID, new PoliciesSettingsBuilder());
  builders.set(PrintingSettings.TYPE_ID, new PrintingSettingsBuilder());
  builders.set(PoolAttendanceComponent.TYPE_ID, new PoolAttendanceComponentBuilder());
  builders.set(PoolAttendanceGroup.TYPE_ID, new PoolAttendanceGroupBuilder());
  builders.set(PoolBookingSettings.TYPE_ID, new PoolBookingSettingsBuilder());
  builders.set(PoolBookingSettingsComponent.TYPE_ID, new PoolBookingSettingsComponentBuilder());
  builders.set(PoolCheckIn.TYPE_ID, new PoolCheckInBuilder());
  builders.set(PoolCheckInEvent.TYPE_ID, new PoolCheckInEventBuilder());
  builders.set(PoolCheckOutEvent.TYPE_ID, new PoolCheckOutEventBuilder());
  builders.set(PoolPricingSettings.TYPE_ID, new PoolPricingSettingsBuilder());
  builders.set(PoolPricingSettingsComponent.TYPE_ID, new PoolPricingSettingsComponentBuilder());
  builders.set(PoolReservation.TYPE_ID, new PoolReservationBuilder());
  builders.set(PoolReservationCreatedEvent.TYPE_ID, new PoolReservationCreatedEventBuilder());
  builders.set(PoolReservationDeletedEvent.TYPE_ID, new PoolReservationDeletedEventBuilder());
  builders.set(PoolServiceDurationComponent.TYPE_ID, new PoolServiceDurationComponentBuilder());
  builders.set(PoolWeeklyScheduleComponent.TYPE_ID, new PoolWeeklyScheduleComponentBuilder());
  builders.set(PredefinedTemplateComponent.TYPE_ID, new PredefinedTemplateIdComponentBuilder());
  builders.set(PriceBasedSerialNumberPool.TYPE_ID, new PriceBasedSerialNumberPoolBuilder());
  builders.set(PriceRange.TYPE_ID, new PriceRangeBuilder());
  builders.set(PricingDetailsComponent.TYPE_ID, new PricingDetailsComponentBuilder());
  builders.set(PrintedCardCover.TYPE_ID, new PrintedCardCoverBuilder());
  builders.set(PrintedCardCoverComponent.TYPE_ID, new PrintedCardCoverComponentBuilder());
  builders.set(PrintedTicketOrderCreatedEvent.TYPE_ID, new PrintedTicketOrderCreatedEventBuilder());
  builders.set(Product.TYPE_ID, new ProductBuilder());
  builders.set(ProductCartItemDto.TYPE_ID, new ProductCartItemDtoBuilder());
  builders.set(ProductAssignment.TYPE_ID, new ProductAssignmentBuilder());
  builders.set(ProductListComponent.TYPE_ID, new ProductListComponentBuilder());
  builders.set(OrderArtifactsComponent.TYPE_ID, new OrderArtifactsComponentBuilder());
  builders.set(ProductOrderItem.TYPE_ID, new ProductOrderItemBuilder());
  builders.set(ProductSellingSettings.TYPE_ID, new ProductSellingSettingsBuilder());
  builders.set(ProfileElement.TYPE_ID, new ProfileElementBuilder());
  builders.set(ProfileElementCacheComponent.TYPE_ID, new ProfileElementCacheComponentBuilder());
  builders.set(ProfileElementGroupComponent.TYPE_ID, new ProfileElementGroupComponentBuilder());
  builders.set(ProfileElementListComponent.TYPE_ID, new ProfileElementListComponentBuilder());
  builders.set(ProfileElementRef.TYPE_ID, new ProfileElementRefBuilder());
  builders.set(ProfilePageLink.TYPE_ID, new ProfilePageLinkBuilder());
  builders.set(ProfilePageListComponent.TYPE_ID, new ProfilePageListComponentBuilder());
  builders.set(ProfilePhotosComponent.TYPE_ID, new ProfilePhotosComponentBuilder());
  builders.set(PromoCodeConsentComponent.TYPE_ID, new PromoCodeConsentComponentBuilder());
  builders.set(PromoterEventStats.TYPE_ID, new PromoterEventStatsBuilder);
  builders.set(PromoterEventSubscription.TYPE_ID, new PromoterEventSubscriptionBuilder());
  builders.set(PromoterProfile.TYPE_ID, new PromoterProfileBuilder());
  builders.set(PromoterStats.TYPE_ID, new PromoterStatsBuilder());
  builders.set(ProtocolProductOrderCreatedEvent.TYPE_ID, new ProtocolProductOrderCreatedEventBuilder());
  builders.set(ProtocolTicketOrderCreatedEvent.TYPE_ID, new ProtocolTicketOrderCreatedEventBuilder());
  builders.set(PublicProfileClassificationComponent.TYPE_ID, new PublicProfileClassificationComponentBuilder());
  builders.set(PublishingStatusComponent.TYPE_ID, new PublishingStatusComponentBuilder());
  builders.set(PushNotificationIntent.TYPE_ID, new PushNotificationIntentBuilder());
  builders.set(RateLimiterLock.TYPE_ID, new RateLimiterLockBuilder());
  builders.set(LegacyReceipt.TYPE_ID, new LegacyReceiptBuilder());
  builders.set(Refund.TYPE_ID, new RefundBuilder());
  builders.set(RelatedPointsOfInterestComponent.TYPE_ID, new RelatedPointsOfInterestComponentBuilder());
  builders.set(RemoveEventFromSeatedOpenAccessProtocol.TYPE_ID, new RemoveEventFromSeatedOpenAccessProtocolBuilder());
  builders.set(RescheduleNotConfirmedEvent.TYPE_ID, new RescheduleNotConfirmedEventBuilder());
  builders.set(RescheduleNotificationEvent.TYPE_ID, new RescheduleNotificationEventBuilder());
  builders.set(ResponsiveImageComponent.TYPE_ID, new ResponsiveImageComponentBuilder());
  builders.set(ReviewComponent.TYPE_ID, new ReviewComponentBuilder());
  builders.set(ReviewStatistics.TYPE_ID, new ReviewStatisticsBuilder());
  builders.set(RichDescription.TYPE_ID, new RichDescriptionBuilder());
  builders.set(RoomSearchData.TYPE_ID, new RoomSearchDataBuilder());
  builders.set(ScanStatistics.TYPE_ID, new ScanStatisticsBuilder());
  builders.set(ScheduledOrderComponent.TYPE_ID, new ScheduledOrderComponentBuilder());
  builders.set(ScheduleTemplate.TYPE_ID, new ScheduleTemplateBuilder());
  builders.set(ScheduleTimeSpan.TYPE_ID, new ScheduleTimeSpanBuilder());
  builders.set(SearchSnapshot.TYPE_ID, new SearchSnapshotBuilder());
  builders.set(LegacySeatedAccessPassCartItemDto.TYPE_ID, new LegacySeatedAccessPassCartItemDtoBuilder());
  builders.set(SeatedOfflineEventTicketSwapEntry.TYPE_ID, new SeatedOfflineEventTicketSwapEntryBuilder());
  builders.set(SeatedOnlineEventTicketSwapEntry.TYPE_ID, new SeatedOnlineEventTicketSwapEntryBuilder());
  builders.set(SeatedOpenAccessProtocol.TYPE_ID, new SeatedOpenAccessProtocolBuilder());
  builders.set(Stage.TYPE_ID, new StageBuilder());
  builders.set(StageEntry.TYPE_ID, new StageEntryBuilder());
  builders.set(StagedSeatedOpenAccessProtocol.TYPE_ID, new StagedSeatedOpenAccessProtocolBuilder());
  builders.set(SeatingLayout.TYPE_ID, new SeatingLayoutBuilder());
  builders.set(SeatingOptions.TYPE_ID, new SeatingOptionsBuilder());
  builders.set(SeatingRoom.TYPE_ID, new SeatingRoomBuilder());
  builders.set(SeatingSettingsComponent.TYPE_ID, new SeatingSettingsComponentBuilder());
  builders.set(SeatReservation.TYPE_ID, new SeatReservationBuilder());
  builders.set(SeatReservationItem.TYPE_ID, new SeatReservationItemBuilder());
  builders.set(SeatStateStatistics.TYPE_ID, new SeatStateStatisticsBuilder());
  builders.set(Secret.TYPE_ID, new SecretBuilder());
  builders.set(Service.TYPE_ID, new ServiceBuilder());
  builders.set(ServiceAttendanceComponent.TYPE_ID, new ServiceAttendanceComponentBuilder());
  builders.set(ServiceAttendanceGroup.TYPE_ID, new ServiceAttendanceGroupBuilder());
  builders.set(ServiceAudienceComponent.TYPE_ID, new ServiceAudienceComponentBuilder());
  builders.set(ServiceCapacityComponent.TYPE_ID, new ServiceCapacityComponentBuilder());
  builders.set(ServiceDuration.TYPE_ID, new ServiceDurationBuilder());
  builders.set(ServiceDurationComponent.TYPE_ID, new ServiceDurationComponentBuilder());
  builders.set(ServiceModifier.TYPE_ID, new ServiceModifierBuilder());
  builders.set(ServiceModifierComponent.TYPE_ID, new ServiceModifierComponentBuilder());
  builders.set(ServicePaymentComponent.TYPE_ID, new ServicePaymentComponentBuilder());
  builders.set(ServicePhotosComponent.TYPE_ID, new ServicePhotosComponentBuilder());
  builders.set(ServicePriceComponent.TYPE_ID, new ServicePriceComponentBuilder());
  builders.set(ServiceStaffMembersComponent.TYPE_ID, new ServiceStaffMembersComponentBuilder());
  builders.set(ShardedTicketPool.TYPE_ID, new ShardedTicketPoolBuilder());
  builders.set(ShardedTicketPoolMaintenanceLock.TYPE_ID, new ShardedTicketPoolMaintenanceLockBuilder());
  builders.set(ShortCodePool.TYPE_ID, new ShortCodePoolBuilder());
  builders.set(SoldTicketsPool.TYPE_ID, new SoldTicketsPoolBuilder());
  builders.set(StaffInviteCode.TYPE_ID, new StaffInviteCodeBuilder());
  builders.set(StaffNoteComponent.TYPE_ID, new StaffNoteComponentBuilder());
  builders.set(StaffPrivacySettings.TYPE_ID, new StaffPrivacySettingsBuilder());
  builders.set(StaffProfessionsComponent.TYPE_ID, new StaffProfessionsComponentBuilder());
  builders.set(StaffProfile.TYPE_ID, new StaffProfileBuilder());
  builders.set(StaffRole.TYPE_ID, new StaffRoleBuilder());
  builders.set(StaffSettings.TYPE_ID, new StaffSettingsBuilder());
  builders.set(StandardTicketPool.TYPE_ID, new StandardTicketPoolBuilder());
  builders.set(StaticApplicationFeeProtocol.TYPE_ID, new StaticApplicationFeeProtocolBuilder());
  builders.set(Subscription.TYPE_ID, new SubscriptionBuilder());
  builders.set(SubscriptionBadgeComponent.TYPE_ID, new SubscriptionBadgeComponentBuilder());
  builders.set(SzamlazzInvoicingProtocol.TYPE_ID, new SzamlazzInvoicingProtocolBuilder());
  builders.set(TargetAudience.TYPE_ID, new TargetAudienceBuilder());
  builders.set(TargetAudienceRule.TYPE_ID, new TargetAudienceRuleBuilder());
  builders.set(TaxIdentificationDetails.TYPE_ID, new TaxIdentificationDetailsBuilder());
  builders.set(TaxIdentificationProvidedEvent.TYPE_ID, new TaxIdentificationProvidedEventBuilder());
  builders.set(TaxIdentificationRequest.TYPE_ID, new TaxIdentificationRequestBuilder());
  builders.set(TaxIdentifierTrackingComponent.TYPE_ID, new TaxIdentifierTrackingComponentBuilder());
  builders.set(TemplateBasedSerialNumberPool.TYPE_ID, new TemplateBasedSerialNumberPoolBuilder());
  builders.set(TextFormInputField.TYPE_ID, new TextFormInputFieldBuilder());
  builders.set(ThirdPartyEventTicket.TYPE_ID, new ThirdPartyEventTicketBuilder());
  builders.set(ThirdPartyTicketScannedEvent.TYPE_ID, new ThirdPartyTicketScannedEventBuilder());
  builders.set(TicketBatch.TYPE_ID, new TicketBatchBuilder());
  builders.set(LegacyTicketBookingSettings.TYPE_ID, new LegacyTicketBookingSettingsBuilder());
  builders.set(LegacyTicketBookingSettingsComponent.TYPE_ID, new LegacyTicketBookingSettingsComponentBuilder());
  builders.set(TicketCartItemWithQuantityDto.TYPE_ID, new TicketCartItemWithQuantityDtoBuilder());
  builders.set(TicketCartItemWithSeatingDto.TYPE_ID, new TicketCartItemWithSeatingDtoBuilder());
  builders.set(TicketCartLimitComponent.TYPE_ID, new TicketCartLimitComponentBuilder());
  builders.set(TicketEmailOverride.TYPE_ID, new TicketEmailOverrideBuilder());
  builders.set(TicketGiftCard.TYPE_ID, new TicketGiftCardBuilder());
  builders.set(GiftCardDetails.TYPE_ID, new GiftCardDetailsBuilder());
  builders.set(GiftCard.TYPE_ID, new GiftCardBuilder());
  builders.set(GiftCardRedemption.TYPE_ID, new GiftCardRedemptionBuilder());
  builders.set(GiftCardTemplate.TYPE_ID, new GiftCardTemplateBuilder());
  builders.set(GiftCardVariation.TYPE_ID, new GiftCardVariationBuilder());
  builders.set(GiftCardValidity.TYPE_ID, new GiftCardValidityBuilder());
  builders.set(TicketGiftCardComponent.TYPE_ID, new TicketGiftCardComponentBuilder());
  builders.set(TicketJob.TYPE_ID, new TicketJobBuilder());
  builders.set(TicketOrderCreatedEvent.TYPE_ID, new TicketOrderCreatedEventBuilder());
  builders.set(TicketPoolShard.TYPE_ID, new TicketPoolShardBuilder());
  builders.set(TicketReservation.TYPE_ID, new TicketReservationBuilder());
  builders.set(TicketReservationItem.TYPE_ID, new TicketReservationItemBuilder());
  builders.set(TicketScanColorComponent.TYPE_ID, new TicketScanColorComponentBuilder());
  builders.set(TicketSalesModeComponent.TYPE_ID, new TicketSalesModeComponentBuilder());
  builders.set(TicketSeatColorComponent.TYPE_ID, new TicketSeatColorComponentBuilder());
  builders.set(TicketScannedEvent.TYPE_ID, new TicketScannedEventBuilder());
  builders.set(TicketSellingSettings.TYPE_ID, new TicketSellingSettingsBuilder());
  builders.set(TicketSettings.TYPE_ID, new TicketSettingsBuilder());
  builders.set(TicketCapacityGroup.TYPE_ID, new TicketCapacityGroupBuilder());
  builders.set(EventTicketCapacityGroups.TYPE_ID, new EventTicketCapacityGroupsBuilder());
  builders.set(TicketSupplement.TYPE_ID, new TicketSupplementBuilder());
  builders.set(TicketSupplementSettings.TYPE_ID, new TicketSupplementSettingsBuilder());
  builders.set(TicketSupplementTemplate.TYPE_ID, new TicketSupplementTemplateBuilder());
  builders.set(TicketTemplate.TYPE_ID, new TicketTemplateBuilder());
  builders.set(TicketTemplateCategory.TYPE_ID, new TicketTemplateCategoryBuilder());
  builders.set(TicketTemplateCategoryComponent.TYPE_ID, new TicketTemplateCategoryComponentBuilder());
  builders.set(TicketTemplateComponent.TYPE_ID, new TicketTemplateComponentBuilder());
  builders.set(TicketTemplateRef.TYPE_ID, new TicketTemplateRefBuilder());
  builders.set(CascadingTicketAvailabilityModifier.TYPE_ID, new CascadingTicketAvailabilityModifierBuilder());
  builders.set(TimeOfDay.TYPE_ID, new TimeOfDayBuilder());
  builders.set(TimeSpan.TYPE_ID, new TimeSpanBuilder());
  builders.set(TitleComponent.TYPE_ID, new TitleComponentBuilder());
  builders.set(TouristSignComponent.TYPE_ID, new TouristSignComponentBuilder());
  builders.set(TrackingPromoCode.TYPE_ID, new TrackingPromoCodeBuilder());
  builders.set(TrailComponent.TYPE_ID, new TrailComponentBuilder());
  builders.set(VoucherAttachmentComponent.TYPE_ID, new VoucherAttachmentComponentBuilder());
  builders.set(VoucherForOfflineUsage.TYPE_ID, new VoucherForOfflineUsageBuilder());
  builders.set(WeeklySchedule.TYPE_ID, new WeeklyScheduleBuilder());
  builders.set(WeeklyScheduleDay.TYPE_ID, new WeeklyScheduleDayBuilder());
  builders.set(InvoiceRetryRequest.TYPE_ID, new InvoiceRetryRequestBuilder());
  builders.set(InvoiceSubscriptionRequest.TYPE_ID, new InvoiceSubscriptionRequestBuilder());
  builders.set(ThirdPartyEventComponent.TYPE_ID, new ThirdPartyEventComponentBuilder());
  builders.set(CalendarEventBookingProtocol.TYPE_ID, new CalendarEventBookingProtocolBuilder());
  builders.set(TicketsAndProductsEventBookingProtocol.TYPE_ID, new TicketsAndProductsEventBookingProtocolBuilder());
  builders.set(TicketAsPassEventBookingProtocol.TYPE_ID, new TicketAsPassEventBookingProtocolBuilder());
  builders.set(TicketsOnlyEventBookingProtocol.TYPE_ID, new TicketsOnlyEventBookingProtocolBuilder());
  builders.set(VouchersOnlyEventBookingProtocol.TYPE_ID, new VouchersOnlyEventBookingProtocolBuilder());
  builders.set(FormSubmission.TYPE_ID, new FormSubmissionBuilder());
  builders.set(TextFormSubmissionAnswer.TYPE_ID, new TextFormSubmissionAnswerBuilder());
  builders.set(OptionSelectFormSubmissionAnswer.TYPE_ID, new OptionSelectFormSubmissionAnswerBuilder());
  builders.set(DateTimeFormSubmissionAnswer.TYPE_ID, new DateTimeFormSubmissionAnswerBuilder());
  builders.set(BooleanFormSubmissionAnswer.TYPE_ID, new BooleanFormSubmissionAnswerBuilder());
  builders.set(FormFieldOption.TYPE_ID, new FormFieldOptionBuilder());
  builders.set(FormSubmissionsComponent.TYPE_ID, new FormSubmissionsComponentBuilder());
  builders.set(FormQuestionsComponent.TYPE_ID, new FormQuestionsComponentBuilder());
  builders.set(PaymentProtocol.TYPE_ID, new PaymentProtocolBuilder());
  builders.set(PaymentProtocolSettings.TYPE_ID, new PaymentProtocolSettingsBuilder());
  builders.set(PaymentProtocolComponent.TYPE_ID, new PaymentProtocolComponentBuilder());
  builders.set(SendProductOrderEmailSideEffect.TYPE_ID, new SendProductOrderEmailSideEffectBuilder());
  builders.set(RedirectAfterPaymentSideEffect.TYPE_ID, new RedirectAfterPaymentSideEffectBuilder());
  builders.set(DeferOrderCompletionSideEffect.TYPE_ID, new DeferOrderCompletionSideEffectBuilder());
  builders.set(CreateOpenAccessPassFromTicketSideEffect.TYPE_ID, new CreateOpenAccessPassFromTicketSideEffectBuilder());
  builders.set(SendOnlyPaymentConfirmationSideEffect.TYPE_ID, new SendOnlyPaymentConfirmationSideEffectBuilder());
  builders.set(CreateOpenTicketPassSideEffect.TYPE_ID, new CreateOpenTicketPassSideEffectBuilder());
  builders.set(CreateSingleOpenAccessPassSideEffect.TYPE_ID, new CreateSingleOpenAccessPassSideEffectBuilder());
  builders.set(CreateMultiOpenAccessPassSideEffect.TYPE_ID, new CreateMultiOpenAccessPassSideEffectBuilder());
  builders.set(GenerateProductQrSideEffect.TYPE_ID, new GenerateProductQrSideEffectBuilder());
  builders.set(GenerateProductPdfSideEffect.TYPE_ID, new GenerateProductPdfSideEffectBuilder());
  builders.set(OkeokeProductsOutboundWebhookProtocol.TYPE_ID, new OkeokeProductsOutboundWebhookProtocolBuilder());
  builders.set(OutboundWebhookSideEffect.TYPE_ID, new OutboundWebhookSideEffectBuilder());
  builders.set(BackstagePos.TYPE_ID, new BackstagePosBuilder());
  builders.set(GenericProductQrObjectReference.TYPE_ID, new GenericProductQrObjectReferenceBuilder());
  builders.set(GenericSellingEventBookingProtocol.TYPE_ID, new GenericSellingEventBookingProtocolBuilder());
  builders.set(GenericOrder.TYPE_ID, new GenericOrderBuilder());
  builders.set(GenericOrderTicketEntry.TYPE_ID, new GenericOrderTicketEntryBuilder());
  builders.set(GenericOrderDonationEntry.TYPE_ID, new GenericOrderDonationEntryBuilder());
  builders.set(GenericOrderProductEntry.TYPE_ID, new GenericOrderProductEntryBuilder());
  builders.set(GenericOrderVoucherEntry.TYPE_ID, new GenericOrderVoucherEntryBuilder());
  builders.set(OnlineTransactionDetails.TYPE_ID, new OnlineTransactionDetailsBuilder());
  builders.set(DonationCartItemDto.TYPE_ID, new DonationCartItemDtoBuilder());
  builders.set(OfflineEventCartEntryDto.TYPE_ID, new OfflineEventCartEntryDtoBuilder());
  builders.set(GenericOrderCreatedEntry.TYPE_ID, new GenericOrderCreatedEntryBuilder());
  builders.set(GenericOrderCompletedEntry.TYPE_ID, new GenericOrderCompletedEntryBuilder());
  builders.set(GenericOrderAbortedEntry.TYPE_ID, new GenericOrderAbortedEntryBuilder());
  builders.set(GenericOrderRefundedEntry.TYPE_ID, new GenericOrderRefundedEntryBuilder());
  builders.set(GenericOrderCanceledEntry.TYPE_ID, new GenericOrderCanceledEntryBuilder());
  builders.set(GenericOrderTicketSupplementEntry.TYPE_ID, new GenericOrderTicketSupplementEntryBuilder());
  builders.set(TicketSupplementRef.TYPE_ID, new TicketSupplementRefBuilder());
  builders.set(OfflineGenericOrderCreatedEvent.TYPE_ID, new OfflineGenericOrderCreatedEventBuilder());
  builders.set(OrderDiscountCodeComponent.TYPE_ID, new OrderDiscountCodeComponentBuilder());
  builders.set(OpenAccessPassDetails.TYPE_ID, new OpenAccessPassDetailsBuilder());
  builders.set(OverrideNameComponent.TYPE_ID, new OverrideNameComponentBuilder());
  builders.set(OfflineInvoicingDetails.TYPE_ID, new OfflineInvoicingDetailsBuilder());
  builders.set(LegacyReceiptGroup.TYPE_ID, new LegacyReceiptGroupBuilder());
  builders.set(CreateReceiptSideEffect.TYPE_ID, new CreateReceiptSideEffectBuilder());
  builders.set(OfflineTransactionDetails.TYPE_ID, new OfflineTransactionDetailsBuilder());
  builders.set(GenericOrderEntryCanceledEvent.TYPE_ID, new GenericOrderEntryCanceledEventBuilder());
  builders.set(GenericSeatedEventTicketSwapEntry.TYPE_ID, new GenericSeatedEventTicketSwapEntryBuilder());
  builders.set(OfflineReceipt.TYPE_ID, new OfflineReceiptBuilder());
  builders.set(OfflineReceiptAction.TYPE_ID, new OfflineReceiptActionBuilder());
  builders.set(OfflineReceiptGroup.TYPE_ID, new OfflineReceiptGroupBuilder());
  builders.set(CustomerLocation.TYPE_ID, new CustomerLocationBuilder());
  builders.set(BirthDate.TYPE_ID, new BirthDateBuilder());
  builders.set(CartCustomerDto.TYPE_ID, new CartCustomerDtoBuilder());
  builders.set(OfflineProductCartDto.TYPE_ID, new OfflineProductCartDtoBuilder());
  builders.set(GenericOrderGiftCardEntry.TYPE_ID, new GenericOrderGiftCardEntryBuilder());
  builders.set(GiftCardSellingSettings.TYPE_ID, new GiftCardSellingSettingsBuilder());
  builders.set(CreateTicketGiftCardSideEffect.TYPE_ID, new CreateTicketGiftCardSideEffectBuilder());
  builders.set(CreateMultiGiftCardSideEffect.TYPE_ID, new CreateMultiGiftCardSideEffectBuilder());
  builders.set(OpenAccessPassCreatedForLegacyBackendEntry.TYPE_ID, new OpenAccessPassCreatedForLegacyBackendEntryBuilder());
  builders.set(OpenAccessPassModifiedEventsEntry.TYPE_ID, new OpenAccessPassModifiedEventsEntryBuilder());
  builders.set(OpenAccessPassModifiedMaxCountEntry.TYPE_ID, new OpenAccessPassModifiedMaxCountEntryBuilder());
  builders.set(OpenAccessPassRefundedForLegacyBackendEntry.TYPE_ID, new OpenAccessPassRefundedForLegacyBackendEntryBuilder());
  builders.set(SeatedOpenAccessPassMovedEntry.TYPE_ID, new SeatedOpenAccessPassMovedEntryBuilder());
  builders.set(SeatedOpenAccessPassSwappedEntry.TYPE_ID, new SeatedOpenAccessPassSwappedEntryBuilder());

  return builders;
}

export function initDataModelFactory(args: {
    databaseIdGenerator: DatabaseIdGenerator,
    customBuilders?: Map<string, unknown>,
    unknownTypePolicy?: UnknownDataModelTypePolicy
}): void {
  const builders = getDefaultBuilders();

  if(isNotNullOrUndefined(args.customBuilders)) {
    for(const [key, value] of args.customBuilders) {
      builders.set(key, value);
    }
  }

  DataModelFactory.ensureInitialized(
      builders,
      args.databaseIdGenerator,
      args.unknownTypePolicy ?? UnknownDataModelTypePolicy.Log,
  );
}

export function initBinaryBlobFactory(converter: IBinaryBlobConverter): void {
  BinaryBlobFactory.ensureInitialized(converter);
}
